import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _typeof from "babel-runtime/helpers/typeof";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable eqeqeq */
/* eslint-disable no-empty */
/* eslint-disable func-style */
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from 'detect-it';
import axios from 'axios';
import Flickity from 'flickity';

var customMethods = {
  data: function data() {
    return {
      // your data here
      iscompareLoaded: false,
      compareProducts: [],
      compareProDetails: [],
      comparePropArray: [],
      WarrantyProductsHandle: '',
      WarrantyVariantID: '',
      isAvailable: true,
      isNotAvailable: false,
      isAvailableShip: false,
      isBoxAvailable: false,
      orderTrackingData: [],
      installProductHandle: '',
      itemModalImg: [],
      installVariantId: '',
      isTermsChecked: false,
      InstPrdDetails: {},
      grillProductHandle: '',
      itemGrillModalImg: [],
      grillVariantId: '',
      GrillPrdDetails: {}
    };
  },


  methods: {
    _initCustomMethods: function _initCustomMethods() {
      // custom JS code
      app._klaviyoSubscription();
      app._projectSlider();
      app._kitchenboxSlider();
      app._megaMenu();
      app._viewmore();
      app._cyberMenu();
      app._collectionFilter();
      app._startEndDateTimer();
      setTimeout(function () {
        app._changeKCBox();
      }, 4000);
      app._changeImage();
      app._customQuickView();
      app._customURL();

      !function (i) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery);
      }(function (i) {
        "use strict";
        var e = window.Slick || {};(e = function () {
          var e = 0;return function (t, o) {
            var s,
                n = this;n.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: i(t), appendDots: i(t), arrows: !0, asNavFor: null, prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>', nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function customPaging(e, t) {
                return i('<button type="button" data-role="none" role="button" tabindex="0" />').text(t + 1);
              }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", edgeFriction: .35, fade: !1, focusOnSelect: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", mobileFirst: !1, pauseOnHover: !0, pauseOnFocus: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rows: 1, rtl: !1, slide: "", slidesPerRow: 1, slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, useTransform: !0, variableWidth: !1, vertical: !1, verticalSwiping: !1, waitForAnimate: !0, zIndex: 1e3 }, n.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, $list: null, touchObject: {}, transformsEnabled: !1, unslicked: !1 }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
          };
        }()).prototype.activateADA = function () {
          this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
          var s = this;if ("boolean" == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e);
          }), s.$slidesCache = s.$slides, s.reinit();
        }, e.prototype.animateHeight = function () {
          var i = this;if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({ height: e }, i.options.speed);
          }
        }, e.prototype.animateSlide = function (e, t) {
          var o = {},
              s = this;s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({ animStart: s.currentLeft }).animate({ animStart: e }, { duration: s.options.speed, easing: s.options.easing, step: function step(i) {
              i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o));
            }, complete: function complete() {
              t && t.call();
            } })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
            s.disableTransition(), t.call();
          }, s.options.speed));
        }, e.prototype.getNavTarget = function () {
          var e = this.options.asNavFor;return e && null !== e && (e = i(e).not(this.$slider)), e;
        }, e.prototype.asNavFor = function (e) {
          var t = this.getNavTarget();null !== t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t.each(function () {
            var t = i(this).slick("getSlick");t.unslicked || t.slideHandler(e, !0);
          });
        }, e.prototype.applyTransition = function (i) {
          var e = this,
              t = {};!1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }, e.prototype.autoPlay = function () {
          var i = this;i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
        }, e.prototype.autoPlayClear = function () {
          this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }, e.prototype.autoPlayIterator = function () {
          var i = this,
              e = i.currentSlide + i.options.slidesToScroll;i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e));
        }, e.prototype.buildArrows = function () {
          var e = this;!0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
        }, e.prototype.buildDots = function () {
          var e,
              t,
              o = this;if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
            for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
              t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            }o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
          }
        }, e.prototype.buildOut = function () {
          var e = this;e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "");
          }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable");
        }, e.prototype.buildRows = function () {
          var i,
              e,
              t,
              o,
              s,
              n,
              r,
              l = this;if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
            for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
              var d = document.createElement("div");for (e = 0; e < l.options.rows; e++) {
                var a = document.createElement("div");for (t = 0; t < l.options.slidesPerRow; t++) {
                  var c = i * r + (e * l.options.slidesPerRow + t);n.get(c) && a.appendChild(n.get(c));
                }d.appendChild(a);
              }o.appendChild(d);
            }l.$slider.empty().append(o), l.$slider.children().children().children().css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" });
          }
        }, e.prototype.checkResponsive = function (e, t) {
          var o,
              s,
              n,
              r = this,
              l = !1,
              d = r.$slider.width(),
              a = window.innerWidth || i(window).width();if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (o in s = null, r.breakpoints) {
              r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            }null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
          }
        }, e.prototype.changeSlide = function (e, t) {
          var o,
              s,
              n = this,
              r = i(e.currentTarget);switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), o = n.slideCount % n.options.slidesToScroll != 0 ? 0 : (n.slideCount - n.currentSlide) % n.options.slidesToScroll, e.data.message) {case "previous":
              s = 0 === o ? n.options.slidesToScroll : n.options.slidesToShow - o, n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide - s, !1, t);break;case "next":
              s = 0 === o ? n.options.slidesToScroll : o, n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide + s, !1, t);break;case "index":
              var l = 0 === e.data.index ? 0 : e.data.index || r.index() * n.options.slidesToScroll;n.slideHandler(n.checkNavigable(l), !1, t), r.children().trigger("focus");break;default:
              return;}
        }, e.prototype.checkNavigable = function (i) {
          var e, t;if (t = 0, i > (e = this.getNavigableIndexes())[e.length - 1]) i = e[e.length - 1];else for (var o in e) {
            if (i < e[o]) {
              i = t;break;
            }t = e[o];
          }return i;
        }, e.prototype.cleanUpEvents = function () {
          var e = this;e.options.dots && null !== e.$dots && i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), i(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
        }, e.prototype.cleanUpSlideEvents = function () {
          var e = this;e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }, e.prototype.cleanUpRows = function () {
          var i,
              e = this;e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
        }, e.prototype.clickHandler = function (i) {
          !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
        }, e.prototype.destroy = function (e) {
          var t = this;t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            i(this).attr("style", i(this).data("originalStyling"));
          }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]);
        }, e.prototype.disableTransition = function (i) {
          var e = this,
              t = {};t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
        }, e.prototype.fadeSlide = function (i, e) {
          var t = this;!1 === t.cssTransitions ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }), e && setTimeout(function () {
            t.disableTransition(i), e.call();
          }, t.options.speed));
        }, e.prototype.fadeSlideOut = function (i) {
          var e = this;!1 === e.cssTransitions ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
          var e = this;null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
        }, e.prototype.focusHandler = function () {
          var e = this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (t) {
            t.stopImmediatePropagation();var o = i(this);setTimeout(function () {
              e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay());
            }, 0);
          });
        }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
          return this.currentSlide;
        }, e.prototype.getDotCount = function () {
          var i = this,
              e = 0,
              t = 0,
              o = 0;if (!0 === i.options.infinite) for (; e < i.slideCount;) {
            ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
          } else if (!0 === i.options.centerMode) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
            ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
          } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);return o - 1;
        }, e.prototype.getLeft = function (i) {
          var e,
              t,
              o,
              s = this,
              n = 0;return s.slideOffset = 0, t = s.$slides.first().outerHeight(!0), !0 === s.options.infinite ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1, n = t * s.options.slidesToShow * -1), s.slideCount % s.options.slidesToScroll != 0 && i + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (i > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (i - s.slideCount)) * s.slideWidth * -1, n = (s.options.slidesToShow - (i - s.slideCount)) * t * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1, n = s.slideCount % s.options.slidesToScroll * t * -1))) : i + s.options.slidesToShow > s.slideCount && (s.slideOffset = (i + s.options.slidesToShow - s.slideCount) * s.slideWidth, n = (i + s.options.slidesToShow - s.slideCount) * t), s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0, n = 0), !0 === s.options.centerMode && !0 === s.options.infinite ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : !0 === s.options.centerMode && (s.slideOffset = 0, s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)), e = !1 === s.options.vertical ? i * s.slideWidth * -1 + s.slideOffset : i * t * -1 + n, !0 === s.options.variableWidth && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow), e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === s.options.centerMode && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow + 1), e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (s.$list.width() - o.outerWidth()) / 2)), e;
        }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
          return this.options[i];
        }, e.prototype.getNavigableIndexes = function () {
          var i,
              e = this,
              t = 0,
              o = 0,
              s = [];for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) {
            s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
          }return s;
        }, e.prototype.getSlick = function () {
          return this;
        }, e.prototype.getSlideCount = function () {
          var e,
              t,
              o = this;return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
            if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1;
          }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll;
        }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
          this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
        }, e.prototype.init = function (e) {
          var t = this;i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
        }, e.prototype.initADA = function () {
          var e = this;e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }), e.$slideTrack.attr("role", "listbox"), e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
            i(this).attr({ role: "option", "aria-describedby": "slick-slide" + e.instanceUid + t });
          }), null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function (t) {
            i(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + e.instanceUid + t, id: "slick-slide" + e.instanceUid + t });
          }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), e.activateADA();
        }, e.prototype.initArrowEvents = function () {
          var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide));
        }, e.prototype.initDotEvents = function () {
          var e = this;!0 === e.options.dots && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
        }, e.prototype.initSlideEvents = function () {
          var e = this;e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
        }, e.prototype.initializeEvents = function () {
          var e = this;e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
        }, e.prototype.initUI = function () {
          var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
        }, e.prototype.keyHandler = function (i) {
          var e = this;i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
        }, e.prototype.lazyLoad = function () {
          var e,
              t,
              o = this;function s(e) {
            i("img[data-lazy]", e).each(function () {
              var e = i(this),
                  t = i(this).attr("data-lazy"),
                  s = document.createElement("img");s.onload = function () {
                e.animate({ opacity: 0 }, 100, function () {
                  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr("data-lazy").removeClass("slick-loading");
                  }), o.$slider.trigger("lazyLoaded", [o, e, t]);
                });
              }, s.onerror = function () {
                e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, e, t]);
              }, s.src = t;
            });
          }!0 === o.options.centerMode ? !0 === o.options.infinite ? t = (e = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (e = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)), t = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (e = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide, t = Math.ceil(e + o.options.slidesToShow), !0 === o.options.fade && (e > 0 && e--, t <= o.slideCount && t++)), s(o.$slider.find(".slick-slide").slice(e, t)), o.slideCount <= o.options.slidesToShow ? s(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? s(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && s(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow));
        }, e.prototype.loadSlider = function () {
          var i = this;i.setPosition(), i.$slideTrack.css({ opacity: 1 }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
        }, e.prototype.next = e.prototype.slickNext = function () {
          this.changeSlide({ data: { message: "next" } });
        }, e.prototype.orientationChange = function () {
          this.checkResponsive(), this.setPosition();
        }, e.prototype.pause = e.prototype.slickPause = function () {
          this.autoPlayClear(), this.paused = !0;
        }, e.prototype.play = e.prototype.slickPlay = function () {
          var i = this;i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
        }, e.prototype.postSlide = function (i) {
          var e = this;e.unslicked || (e.$slider.trigger("afterChange", [e, i]), e.animating = !1, e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && e.initADA());
        }, e.prototype.prev = e.prototype.slickPrev = function () {
          this.changeSlide({ data: { message: "previous" } });
        }, e.prototype.preventDefault = function (i) {
          i.preventDefault();
        }, e.prototype.progressiveLazyLoad = function (e) {
          e = e || 1;var t,
              o,
              s,
              n = this,
              r = i("img[data-lazy]", n.$slider);r.length ? (t = r.first(), o = t.attr("data-lazy"), (s = document.createElement("img")).onload = function () {
            t.attr("src", o).removeAttr("data-lazy").removeClass("slick-loading"), !0 === n.options.adaptiveHeight && n.setPosition(), n.$slider.trigger("lazyLoaded", [n, t, o]), n.progressiveLazyLoad();
          }, s.onerror = function () {
            e < 3 ? setTimeout(function () {
              n.progressiveLazyLoad(e + 1);
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, t, o]), n.progressiveLazyLoad());
          }, s.src = o) : n.$slider.trigger("allImagesLoaded", [n]);
        }, e.prototype.refresh = function (e) {
          var t,
              o,
              s = this;o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, { currentSlide: t }), s.init(), e || s.changeSlide({ data: { message: "index", index: t } }, !1);
        }, e.prototype.registerBreakpoints = function () {
          var e,
              t,
              o,
              s = this,
              n = s.options.responsive || null;if ("array" === i.type(n) && n.length) {
            for (e in s.respondTo = s.options.respondTo || "window", n) {
              if (o = s.breakpoints.length - 1, t = n[e].breakpoint, n.hasOwnProperty(e)) {
                for (; o >= 0;) {
                  s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                }s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
              }
            }s.breakpoints.sort(function (i, e) {
              return s.options.mobileFirst ? i - e : e - i;
            });
          }
        }, e.prototype.reinit = function () {
          var e = this;e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]);
        }, e.prototype.resize = function () {
          var e = this;i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
            e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
          }, 50));
        }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
          var o = this;if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit();
        }, e.prototype.setCSS = function (i) {
          var e,
              t,
              o = this,
              s = {};!0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)));
        }, e.prototype.setDimensions = function () {
          var i = this;!1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();!1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
        }, e.prototype.setFade = function () {
          var e,
              t = this;t.$slides.each(function (o, s) {
            e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({ position: "relative", right: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 }) : i(s).css({ position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 });
          }), t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 });
        }, e.prototype.setHeight = function () {
          var i = this;if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height", e);
          }
        }, e.prototype.setOption = e.prototype.slickSetOption = function () {
          var e,
              t,
              o,
              s,
              n,
              r = this,
              l = !1;if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;else if ("multiple" === n) i.each(o, function (i, e) {
            r.options[i] = e;
          });else if ("responsive" === n) for (t in s) {
            if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
              for (e = r.options.responsive.length - 1; e >= 0;) {
                r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
              }r.options.responsive.push(s[t]);
            }
          }l && (r.unload(), r.reinit());
        }, e.prototype.setPosition = function () {
          var i = this;i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
        }, e.prototype.setProps = function () {
          var i = this,
              e = document.body.style;i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType;
        }, e.prototype.setSlideClasses = function (i) {
          var e,
              t,
              o,
              s,
              n = this;t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode ? (e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")) : i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === n.options.lazyLoad && n.lazyLoad();
        }, e.prototype.setupInfinite = function () {
          var e,
              t,
              o,
              s = this;if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
            for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
              t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            }for (e = 0; e < o; e += 1) {
              t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            }s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
              i(this).attr("id", "");
            });
          }
        }, e.prototype.interrupt = function (i) {
          i || this.autoPlay(), this.interrupted = i;
        }, e.prototype.selectHandler = function (e) {
          var t = this,
              o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
              s = parseInt(o.attr("data-slick-index"));if (s || (s = 0), t.slideCount <= t.options.slidesToShow) return t.setSlideClasses(s), void t.asNavFor(s);t.slideHandler(s);
        }, e.prototype.slideHandler = function (i, e, t) {
          var o,
              s,
              n,
              r,
              l,
              d,
              a = this;if (e = e || !1, (!0 !== a.animating || !0 !== a.options.waitForAnimate) && !(!0 === a.options.fade && a.currentSlide === i || a.slideCount <= a.options.slidesToShow)) if (!1 === e && a.asNavFor(i), o = i, l = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
            a.postSlide(o);
          }) : a.postSlide(o));else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
            a.postSlide(o);
          }) : a.postSlide(o));else {
            if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (d = (d = a.getNavTarget()).slick("getSlick")).slideCount <= d.options.slidesToShow && d.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
              a.postSlide(s);
            })) : a.postSlide(s), void a.animateHeight();!0 !== t ? a.animateSlide(l, function () {
              a.postSlide(s);
            }) : a.postSlide(s);
          }
        }, e.prototype.startLoad = function () {
          var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading");
        }, e.prototype.swipeDirection = function () {
          var i,
              e,
              t,
              o,
              s = this;return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical";
        }, e.prototype.swipeEnd = function (i) {
          var e,
              t,
              o = this;if (o.dragging = !1, o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {case "left":case "down":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;break;case "right":case "up":
                e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;}"vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]));
          } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
        }, e.prototype.swipeHandler = function (i) {
          var e = this;if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {case "start":
              e.swipeStart(i);break;case "move":
              e.swipeMove(i);break;case "end":
              e.swipeEnd(i);}
        }, e.prototype.swipeMove = function (i) {
          var e,
              t,
              o,
              s,
              n,
              r = this;return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!r.dragging || n && 1 !== n.length) && (e = r.getLeft(r.currentSlide), r.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, r.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))), !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))), "vertical" !== (t = r.swipeDirection()) ? (void 0 !== i.originalEvent && r.touchObject.swipeLength > 4 && i.preventDefault(), s = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1), !0 === r.options.verticalSwiping && (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1), o = r.touchObject.swipeLength, r.touchObject.edgeHit = !1, !1 === r.options.infinite && (0 === r.currentSlide && "right" === t || r.currentSlide >= r.getDotCount() && "left" === t) && (o = r.touchObject.swipeLength * r.options.edgeFriction, r.touchObject.edgeHit = !0), !1 === r.options.vertical ? r.swipeLeft = e + o * s : r.swipeLeft = e + o * (r.$list.height() / r.listWidth) * s, !0 === r.options.verticalSwiping && (r.swipeLeft = e + o * s), !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null, !1) : void r.setCSS(r.swipeLeft))) : void 0);
        }, e.prototype.swipeStart = function (i) {
          var e,
              t = this;if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0;
        }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
          var i = this;null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
        }, e.prototype.unload = function () {
          var e = this;i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }, e.prototype.unslick = function (i) {
          var e = this;e.$slider.trigger("unslick", [e, i]), e.destroy();
        }, e.prototype.updateArrows = function () {
          var i = this;Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }, e.prototype.updateDots = function () {
          var i = this;null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"));
        }, e.prototype.visibility = function () {
          var i = this;i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
        }, i.fn.slick = function () {
          var i,
              t,
              o = this,
              s = arguments[0],
              n = Array.prototype.slice.call(arguments, 1),
              r = o.length;for (i = 0; i < r; i++) {
            if ("object" == (typeof s === "undefined" ? "undefined" : _typeof(s)) || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
          }return o;
        };
      });

      app._customHawkSuggestion();
      app._customrecommendation();
      app._customHawkImg();
      if (app.currentTemplate == 'collection' || app.currentTemplate == 'search') {
        var hawkCategoriesImgs = localStorage.getItem('hawkCategoriesImgs');
        if (hawkCategoriesImgs && hawkCategoriesImgs != '' && hawkCategoriesImgs != undefined) {
          app._customHawk();
          app.collection.hawkAllCategories = [];
          app.collection.hawkAvailCategories = [];

          app._ALAcheckFlickity();
        } else {
          setTimeout(function () {
            app._customHawk();
            app.collection.hawkAllCategories = [];
            app.collection.hawkAvailCategories = [];

            app._ALAcheckFlickity();
          }, 2000);
        }
      }

      if (app.currentTemplate == 'search') {
        app._hawkSearch();
      }

      // eslint-disable-next-line eqeqeq
      if (app.currentTemplate == 'compare_page') {
        app._getComparePro();
      }
      if (app.currentTemplate == 'customForm') {
        setTimeout(function () {
          app._contactCaptcha();
        }, 1000);
      }

      if (app.currentTemplate == 'orderTracking') {
        setTimeout(function () {
          app._contactCaptcha();
          app._contactCaptcha2();
        }, 1000);

        if (app._getUrlParameter('token') != '' && app._getUrlParameter('auth_key') != '') {
          $('[data-template="orderTracking"]').addClass('invisible');
          var data = {
            "token": app._getUrlParameter('token'),
            "auth_key": app._getUrlParameter('auth_key')
          };
          $.ajax({
            type: 'POST',
            url: 'https://app.kitchencenter.cl/api/calendar/v2/tracking',
            dataType: 'json',
            data: data,
            success: function success(response) {
              if (response.error) {
                $('[data-template="orderTracking"]').removeClass('invisible');
                app._snotifyMessage('Error', 'Something went wrong, Please try again later!');
                return false;
              } else {
                var prd_imgs = [];
                var response_data = response[0].shopify_order_info;
                var order_lineitems = response_data.line_items;
                order_lineitems.forEach(function (line_item, index) {

                  //// for shipping status 

                  var fulfill_lineitems = response_data.fulfillments;
                  if (fulfill_lineitems != null && fulfill_lineitems.length > 0) {
                    fulfill_lineitems.forEach(function (fulfill_item, ff_index) {
                      fulfill_item.line_items.forEach(function (fulfill_subitem, fl_index) {
                        if (fulfill_subitem.id == line_item.id) {
                          response_data.line_items[index].shipment_status = fulfill_item.shipment_status;
                        }
                      });
                    });
                  }

                  //// end for shipping status 

                  var pr_id = line_item.product_id;

                  var API = '';
                  var shopifyCommonAPI = axios.create({
                    baseURL: '/tools/ha-api/shopify/common',
                    headers: {
                      Accept: 'application/json'
                    }
                  });

                  var config1 = {
                    "url": '/products/' + pr_id + '.json',
                    "method": 'GET',
                    "data": []
                  };
                  try {
                    shopifyCommonAPI.post(API, config1).then(function (prdresponse) {
                      if (prdresponse.data.product.image != null) {
                        prd_imgs.push(pr_id + 'img:' + prdresponse.data.product.image.src);
                      } else {
                        prd_imgs.push(pr_id + 'img:https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg');
                      }
                    });
                  } catch (error) {
                    console.log('error');
                  }

                  var order_data = response_data;
                  order_data.prd_imgs = prd_imgs;
                  app.orderTrackingData = response_data;
                });
              }
            },
            error: function error(data) {
              console.log('error');
              console.log(data);
            }
          });
        }
      }

      if (app.currentTemplate == 'my-orders') {
        if ($('[data-customerid]').data('customerid') == '') {
          document.location.href = '/account';
        } else {
          var config = JSON.stringify({
            "url": '/customers/' + $('[data-customerid]').data('customerid') + '/orders.json?status=any',
            "method": "GET",
            "data": {}
          });
          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("load", function () {
            var response = JSON.parse(xhr.responseText);
            if (response.orders.length > 0) {
              response.orders.forEach(function (item, index) {
                if (item.id == $('[data-order-id]').attr('data-order-id')) {
                  if (item.fulfillments && item.fulfillments.length > 0) {
                    if (item.fulfillments.shipment_status == 'delivered') {
                      $('[data-order-id="' + item.id + '"] .order-inprocess').addClass('invisible');
                      $('[data-order-id="' + item.id + '"] .order-complete').removeClass('invisible');
                    }
                  }
                }
              });
            } else {
              console.log('Order not found');
            }
          });
          xhr.open("POST", "/tools/ha-api/shopify/common");
          xhr.setRequestHeader("Accept", "application/json");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(config);

          $('[data-customerid]').removeClass('invisible');
        }
      }

      setInterval(function () {
        if (app.selectedRegion != null) {
          if (app.selectedRegion !== 'Región Metropolitana') {
            $('.cart-delivery-image').css('opacity', '0.4');
            $('[data-msg-change]').html('<span class="font-weight-bold d-flex align-items-center" style="font-size: 14px;opacity: 1;color: #ccc;">Servicio de instalación via soporte <div class="tooltip-hover ml-1"><img src="https://cdn.shopify.com/s/files/1/0111/6448/3647/files/tooltip_36aa766a-e99b-4a0e-a010-4e2bd3354456.png?v=1638206315&quot; alt="icon" class="image-wrapper w-20"><div class="top bg-white text-black position-absolute text-wrap tooltip-text" style=""><p>Para instalaciones fuera de la Región Metropolitana, por favor contrata el servicio a través de soporte después de realizar tu compra.</p></div></div></span>');
          } else {
            $('[data-msg-change]').html('Agregar servicios de instalación');
            $('[data-msg-change]').css('color', '#000');
            $('.cart-delivery-image').css('opacity', '1');
          }
        }
      }, 500);

      if (app.currentTemplate == 'collection') {
        $('.read_more').click(function () {
          if ($('.faqs-part').hasClass('d-none')) {
            $('.faqs-part').removeClass('d-none');
            $('.collaps_p').addClass('d-none');
            $(this).text('Leer menos');
            $(this).addClass('expnd');
          } else {
            $('.faqs-part').addClass('d-none');
            $('.collaps_p').removeClass('d-none');
            $(this).text('Leer más');
            $(this).removeClass('expnd');
          }
        });
      }

      if (app.currentTemplate == 'my-orders') {
        if ($('[data-customerid]').data('customerid') == '') {
          document.location.href = '/account';
        } else {
          var _config = JSON.stringify({
            "url": '/customers/' + $('[data-customerid]').data('customerid') + '/orders.json?status=any',
            "method": "GET",
            "data": {}
          });
          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("load", function () {
            var response = JSON.parse(xhr.responseText);
            if (response.orders.length > 0) {
              response.orders.forEach(function (item, index) {
                if (item.id == $('[data-order-id]').attr('data-order-id')) {
                  if (item.fulfillments && item.fulfillments.length > 0) {
                    if (item.fulfillments.shipment_status == 'delivered') {
                      $('[data-order-id="' + item.id + '"] .order-inprocess').addClass('invisible');
                      $('[data-order-id="' + item.id + '"] .order-complete').removeClass('invisible');
                    }
                  }
                }
              });
            } else {
              console.log('Order not found');
            }
          });
          xhr.open("POST", "/tools/ha-api/shopify/common");
          xhr.setRequestHeader("Accept", "application/json");
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(_config);

          $('[data-customerid]').removeClass('invisible');
        }
      }

      if (app.currentTemplate == 'account' && $('#registerCustomerPassword').length > 0) {
        $('body').on('keyup keydown touchstart touchend input', '#registerCustomerPassword', function () {
          var pass_txt = $(this).parent('.form-group').find('.pass-wrapper .pass-text').text();
          if (pass_txt == 'The password is too short') {
            $(this).parent('.form-group').find('.pass-wrapper .pass-text').text('La contraseña es muy corta');
          } else if (pass_txt == 'Weak; try combining letters & numbers') {
            $(this).parent('.form-group').find('.pass-wrapper .pass-text').text('Contraseña débil, te sugerimos combinar letras y números.');
          } else if (pass_txt == 'Medium; try using special characters') {
            $(this).parent('.form-group').find('.pass-wrapper .pass-text').text('Contraseña intermedia, puedes incluir caracteres especiales');
          } else if (pass_txt == 'Strong password') {
            $(this).parent('.form-group').find('.pass-wrapper .pass-text').text('Contraseña segura');
          }
        });
      }
      if (app.currentTemplate == 'account' || $('.template-account').length > 0) {
        $('[data-customerRut]').rut({
          formatOn: 'keyup',
          validateOn: 'keyup'
        }).on('rutInvalido', function () {
          $('#errorExplanation').css('display', 'block');
          $('[data-customerrut]').addClass('rut-error');
          if ($('.Rut').length == 0 && $('#error_list').length > 0) {
            $('#error_list').append('<li class="Rut">Rut debe ser un rut válido</li>');
          }
        }).on('rutValido', function () {
          $('[data-customerrut]').removeClass('rut-error');
          $('#error_list .Rut').remove();
          if ($('#error_list li').length <= 0) {
            $('#errorExplanation').css('display', 'none');
          }
        });
        $('#errorExplanation').css('display', 'none');
        if ($('[data-regions]').length) {
          var preselected = 'RM';
          var regionsJson = '';
          var regionsLocalStrg1 = localStorage.getItem('regionsJsonLS');
          if (regionsLocalStrg1 && regionsLocalStrg1 != '' && regionsLocalStrg1 != undefined) {
            var regions = JSON.parse(regionsLocalStrg1);
            regionsJson = regions;
            var homeRegion = '<option disabled selected value="">Selecciona Región</option>';
            var count = 0;
            var checkReg = '';
            $.each(regions, function () {
              $.each(this, function (k, value) {
                if (value.region != 'Regi') {
                  if (value.region != 'Portugal') {
                    // if(preselected != null && preselected != '' && preselected == value.short_code){
                    //   checkReg = ' selected="selected"';
                    // }
                    // else{
                    //   checkReg = '';
                    // }
                    if (count == 0) {
                      homeRegion += '<option value="' + value.region + '"' + checkReg + ' data-region_code="' + value.short_code + '">' + value.region + '</option>';
                    } else {
                      if (homeRegion.indexOf(value.region) == -1) {
                        homeRegion += '<option value="' + value.region + '"' + checkReg + ' data-region_code="' + value.short_code + '">' + value.region + '</option>';
                      }
                    }
                  }
                }
                count++;
              });
            });
            $('[data-regions]').html(homeRegion).show();
            setTimeout(function () {
              if ($('[data-regions]').val() != '') {
                $('[data-regions]').trigger('change');
              }
            }, 400);
          }

          $('[data-regions]').change(function () {
            var val = $(this).val();
            if (val != '' && val != null) {
              var homeDistrict = '';
              $.each(regionsJson[val], function (_k, value) {
                var distt = value.district;
                distt = distt.replaceAll('í', 'i').replaceAll('á', 'a');
                homeDistrict += "<option value=\"" + distt + "\" data-out=\"" + value.is_out_of_delivery + "\">" + distt + "</option>";
              });
              $('[data-district]').html(homeDistrict).show();
              $(this).parents('form').find('[data-district]').trigger('change');
            }
          });
        }

        if ($('[data-reset-success]').length > 0) {
          $('.alert-custom-success').removeClass('d-none').addClass('d-flex');
        }

        var inputTypeNumbers = document.querySelectorAll("input[type=number]");
        for (var a = 0; a < inputTypeNumbers.length; a++) {
          inputTypeNumbers[a].onwheel = function (event) {
            event.target.blur();
          };
        }

        $('[type="number"]').focus(function () {
          if ($(this).parents('.input-group').hasClass('error-phone')) {
            $(this).parents('.input-group').addClass("focused");
          }
        }).blur(function () {
          $(this).parents('.input-group').removeClass("focused");
        });

        $('body').on('change', '[name="address[province]"],[name="address[city]"]', function (e) {
          if ($(e.currentTarget).val() != null) {
            $(e.currentTarget).removeClass('border-danger');
          }
        });
      }

      if ($('.fulfilled_item').length > 0) {
        var _config2 = JSON.stringify({
          "url": '/orders.json?query=' + $('[data-order-id]').attr('data-order-id') + '&status=any',
          "method": "GET",
          "data": {}
        });
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.addEventListener("load", function () {
          var response = JSON.parse(xhr.responseText);
          if (response.orders.length > 0) {
            var get_ind = 0;
            response.orders.forEach(function (item, index) {
              if (item.id == $('[data-order-id]').attr('data-order-id')) {
                get_ind = index;
              }
            });

            var order_lineitems = response.orders[get_ind].line_items;
            order_lineitems.forEach(function (line_item, index) {

              //// for shipping status     
              var fulfill_lineitems = response.orders[get_ind].fulfillments;
              if (fulfill_lineitems != null && fulfill_lineitems.length > 0) {
                fulfill_lineitems.forEach(function (fulfill_item, ff_index) {
                  fulfill_item.line_items.forEach(function (fulfill_subitem, fl_index) {
                    if (fulfill_subitem.id == line_item.id) {
                      response.orders[get_ind].line_items[index].shipment_status = fulfill_item.shipment_status;
                      if (response.orders[get_ind].financial_status == 'paid') {
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step1').addClass('done');
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step2').addClass('active');
                      }

                      if (response.orders[get_ind].financial_status == 'paid' && fulfill_item.shipment_status == 'attempted_delivery' || fulfill_item.shipment_status == 'out_for_delivery' || fulfill_item.shipment_status == 'delivered') {
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step2').addClass('done');
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step3').addClass('active');
                      }

                      if (response.orders[get_ind].financial_status == 'paid' && fulfill_item.shipment_status == 'delivered') {
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step3').addClass('done');
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step4').addClass('active done');
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .review_btn').removeClass('invisible');
                        $('[data_itemid="' + line_item.id + '"].fulfilled_item .step4 [data-item-status]').text('Entregado');
                      }
                    }
                  });
                });
              }
              //// end for shipping status     
            });
          } else {
            console.log('Order not found');
          }
        });
        xhr.open("POST", "/tools/ha-api/shopify/common");
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(_config2);
      }

      if ($('.vuejs-countdown').length) {
        app._countDownLangChange();
      }

      if (app.currentTemplate == 'orderTrackingResult') {
        setTimeout(function () {
          app.orderTrackingNumber = localStorage.getItem('orderTrackingNumber');
          app.ticketTrackingNumber = localStorage.getItem('ticketTrackingNumber');
          if (app.orderTrackingNumber && app.orderTrackingNumber != '' && app.orderTrackingNumber != null) {
            app._trackOrder();
          }
          if (app.ticketTrackingNumber && app.ticketTrackingNumber != '' && app.ticketTrackingNumber != null) {
            app._trackTicket();
          }
        }, 100);
      }

      enquire.register('screen and (max-width: 767px)', {
        match: function match() {
          if ($('#data-refurbish-infobox').length > 0) {
            var flkty = new Flickity('#data-refurbish-infobox', {
              adaptiveHeight: false,
              contain: true,
              cellAlign: 'center',
              wrapAround: false,
              groupCells: '100%',
              prevNextButtons: true,
              pageDots: false,
              arrowShape: { x0: 10, x1: 60, y1: 45, x2: 60, y2: 35, x3: 20 }
            });
          }
          if (app.currentTemplate == 'cart') {
            app.isMobile = true;
          }
        }
      });

      $('[data-clikc-modalDistributed]').click(function () {
        $('#modalDistributed').modal('show');
      });

      if ($('.alternateHome__collection').length) {
        $('.alternateHome__collection').each(function (event) {
          var coll_url = $(this).find('.alternateHome__collection--item:first a').attr('data-coll-url');
          var coll_name = $(this).find('.alternateHome__collection--item:first [data-coll-name]').text();
          $('.collection_name').html(coll_name);
          app._alternateHome('', coll_url);
          $(this).find('.alternateHome__collection--item:first').addClass('is-selected-div');
        });
      }

      $('[data-check-custom]').on('change', function () {
        if ($(this).is(':checked')) {
          $('[data-check-custom]').prop('checked', false);
          $(this).prop('checked', true);
        } else {
          $(this).prop('checked', false);
        }
      });
      // Start of adding active class to active service page
      var current = location.pathname;
      if ($('[data-service-side-bar] .service_page_title').length) {
        $('[data-service-side-bar] .service_page_title a').each(function () {
          var $this = $(this);
          if ($this.attr('href') === current) {
            $this.addClass('active bg-primary text-white').removeClass('bg-light text-dark');
          }
        });
      }
      // End of adding active class to active service page

      $('[data-readmore]').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'none';
      });
      $('[data-readless]').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'block';
      });
      // Start of newsletter klaviyo form code
      var $klaviyoNewsletterForm = $('[data-formsubmit-newsletter]').closest('form');
      var success_msg_newsletter = $klaviyoNewsletterForm.find('[data-subscribe-success]');
      var subscribed_msg_newsletter = $klaviyoNewsletterForm.attr('data-subscribedmsg');

      KlaviyoSubscribe.attachToForms('#NewsletterFooter', {
        hide_form_on_success: false,
        custom_success_message: true,
        success: function success(response) {
          $klaviyoNewsletterForm.find('[data-klaviyo_messages]').show();
          success_msg_newsletter.html(subscribed_msg_newsletter).show();
          setTimeout(function () {
            success_msg_newsletter.hide();
            $klaviyoNewsletterForm.find('[data-klaviyo_messages]').hide();
          }, 3000);
        }
      });
      // End of newsletter klaviyo form code

      // Start of cyber page klaviyo form code
      var $klaviyoCyberForm = $('[data-formsubmit-cyber]').closest('form');
      var success_msg_cyber = $klaviyoCyberForm.find('[data-subscribe-success]');
      var subscribed_msg_cyber = $klaviyoCyberForm.attr('data-subscribedmsg');

      KlaviyoSubscribe.attachToForms('#cyberSubscription', {
        hide_form_on_success: false,
        custom_success_message: true,
        success: function success(response) {
          $klaviyoCyberForm.find('[data-klaviyo_messages]').show();
          success_msg_cyber.html(subscribed_msg_cyber).show();
          setTimeout(function () {
            success_msg_cyber.hide();
            $klaviyoCyberForm.find('[data-klaviyo_messages]').hide();
          }, 3000);
        }
      });
      // End of cyber page klaviyo form code

      // Start of restock master app code
      setTimeout(function () {
        $('body').on('click', '#mhaRnProduct a', function () {
          $('#mhaRnProductModal').modal('show');
        });
      }, 1000);
      // End of newsletter klaviyo form code

      // start of restock master app code
      $('[data-notify]').on('click', function (e) {
        e.preventDefault();
        var val = $(this).closest('[data-back-in-stock]').find('input').val();
        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
        if (val !== '') {
          if (pattern.test(val)) {
            $('#usr').val(val);
            setTimeout(function () {
              $('#signUpForm .subscribe-btn').trigger('click');
              $('[data-on]').removeClass('d-none');
              $('[data-error]').addClass('d-none');
            }, 500);
            setTimeout(function () {
              $('[data-on]').addClass('d-none');
              $('#mhaRnProductModal').modal('hide');
              $('[data-back-in-stock]').find('input').val('');
              $('#usr').val('');
            }, 1500);
          } else {
            $('[data-error]').removeClass('d-none').text('Email is Not Valid.');
          }
        } else {
          $('[data-error]').removeClass('d-none').text('Email no puede estar en blanco');
        }
      });

      var regionsLocalStrg = localStorage.getItem('regionsJsonLS');
      if (regionsLocalStrg && regionsLocalStrg != '' && regionsLocalStrg != undefined) {} else {
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/calendar/regions',
          success: function success(regions) {
            localStorage.setItem('regionsJsonLS', JSON.stringify(regions));
          }
        });
      }

      if (app.currentTemplate != 'cart') {
        setTimeout(function () {
          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '') {
              app.selectedRegion = app.cart.attributes["Region"];
            } else {
              if (app._getCookie('selectedRegion') != undefined && app._getCookie('selectedRegion') != '' && app._getCookie('selectedRegion') != 'selectedRegion') {
                app.selectedRegion = app._getCookie('selectedRegion');
              }
            }
          } else {
            if (app._getCookie('selectedRegion') != undefined && app._getCookie('selectedRegion') != '' && app._getCookie('selectedRegion') != 'selectedRegion') {
              app.selectedRegion = app._getCookie('selectedRegion');
            }
          }
          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
              app.selectedComuna = app.cart.attributes["Comuna"];
            } else {
              if (app._getCookie('selectedComuna') != undefined && app._getCookie('selectedComuna') != '' && app._getCookie('selectedComuna') != 'selectedComuna') {
                app.selectedComuna = app._getCookie('selectedComuna');
              }
            }
          } else {
            if (app._getCookie('selectedComuna') != undefined && app._getCookie('selectedComuna') != '' && app._getCookie('selectedComuna') != 'selectedComuna') {
              app.selectedComuna = app._getCookie('selectedComuna');
            }
          }
        }, 400);
      } else {
        if (app._getCookie('selectedaddress1') != undefined && app._getCookie('selectedaddress1') != '' && app._getCookie('selectedaddress1') != 'selectedaddress1') {
          if (app._getCookie('selCommonC') == app._getCookie('selectedComuna')) {
            setTimeout(function () {
              if (app._getCookie('selectedRegion') != undefined && app._getCookie('selectedRegion') != '' && app._getCookie('selectedRegion') != 'selectedRegion') {
                if (app.cart.attributes != undefined) {
                  if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '') {
                    app.selectedRegion = app.cart.attributes["Region"];
                  } else {
                    app.selectedRegion = app._getCookie('selectedRegion');
                  }
                } else {
                  app.selectedRegion = app._getCookie('selectedRegion');
                }
              }
              if (app._getCookie('selectedComuna') != undefined && app._getCookie('selectedComuna') != '' && app._getCookie('selectedComuna') != 'selectedComuna') {
                if (app.cart.attributes != undefined) {
                  if (app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
                    app.selectedComuna = app.cart.attributes["Comuna"];
                  } else {
                    app.selectedComuna = app._getCookie('selectedComuna');
                  }
                } else {
                  app.selectedComuna = app._getCookie('selectedComuna');
                }
              }
            }, 800);
          } else {
            if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
              app.selectedRegion = app._getCookie('selCommonR');
              document.cookie = 'selectedRegion=' + app._getCookie('selCommonR') + ';path=/' + ';';
            }
            if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
              app.selectedComuna = app._getCookie('selCommonC');
              document.cookie = 'selectedComuna=' + app._getCookie('selCommonC') + ';path=/' + ';';
            }
          }
        }
      }

      if (app.currentTemplate == 'product') {
        setTimeout(function () {
          $('#app').addClass('showtoggle');
          if (app.selectedRegion != null && app.selectedComuna != null) {
            var isinCart = app.cart.items.find(function (item) {
              return parseInt(item.variant_id) === parseInt(app.currentVariant.id);
            });
            $('[data-shipping-check]').trigger('click');
          }

          $(document).click(function (event) {
            if (!$(event.target).closest("#modalForShipping.modal, a[data-selcomuna]").length) {
              $('#modalForShipping').modal('hide');
            }
          });
        }, 700);

        if ($('[data-preorderdel]').length > 0) {
          // $('.preorderDiv a')[0].click();
        }

        if (window.innerWidth < 768) {
          $('.pdp-responsive .mob-toggle').click(function () {
            $(this).parents('.pdp-responsive').toggleClass('show');
          });
        }

        $('body').on('click', '.installation-service label', function () {
          if ($(this).siblings('input.product_install').is(':checked')) {
            $('#modalpdp').find('#accept_terms').prop('checked', false).trigger('change');
          } else {
            $(this).find('a')[0].click();
          }
        });

        $('body').on('click', '.widget-type-product .rebuy-modal-close', function (e) {
          $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
        });
        $('body').on('click', '.grill-service label', function () {
          if ($(this).siblings('input.product_grill').is(':checked')) {
            // $('#modalpdp').find('#accept_terms').prop('checked', false).trigger('change');	
          } else {
            $(this).find('a')[0].click();
          }
        });
      }

      $(document).click(function (event) {
        if (!$(event.target).closest("#querydiv").length) {
          $('#querydiv').hide();
        }
      });

      $(window).on('load', function () {
        if (app.currentTemplate == 'product') {
          if (app._getCookie('selectedRegion') == 'Región Metropolitana') {
            $('.installation-service label, .grill-service label').removeClass('disable');
          }
          setTimeout(function () {
            $('.button-overlay').addClass('d-none');
          }, 2500);
        }
        if (app.currentTemplate == 'collection' || app.currentTemplate == 'search') {
          $('.modal-quickshop [data-addcart-custom]').css({ 'pointer-events': 'auto' });
        }

        if (app.currentTemplate == 'product' || app.currentTemplate == 'cart') {
          $('[data-accept-terms]').on('change', function () {
            if ($('#modalpdp').find('input[name="accept_terms"]').is(':checked')) {
              app.isTermsChecked = true;
            } else {
              app.isTermsChecked = false;
              $('.product_install').prop('checked', false).trigger('change');
            }
          });
        }
      });

      if (app.currentTemplate == 'product' || app.currentTemplate == 'cart') {
        document.addEventListener('rebuy.ready', function (event) {
          if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products' || event.detail.widget.element._prevClass == 'rebuy-upsell-products' || event.detail.widget.element._prevClass == 'rebuy-cart-recommended-products') {
            if ($('.rebuy-product-actions').length > 0) {
              $('.rebuy-product-actions').each(function () {
                if ($(this).find('.button-overlay.click-rebuy').length > 0) {
                  $(this).find('.button-overlay.click-rebuy').remove();
                }
                if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products' || event.detail.widget.element._prevClass == 'rebuy-cart-recommended-products') {
                  $(this).prepend('<span class="button-overlay click-rebuy d-block"></span>');
                } else {
                  $(this).append('<span class="button-overlay click-rebuy d-block"></span>');
                }
              });

              if ($('.rebuy-widget.widget-type-cart .rebuy-modal-close').length > 0) {
                $('body').on('click', '.rebuy-widget.widget-type-cart .rebuy-modal-close', function (e) {
                  $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                });
              }

              $('body').on('click', '.widget-type-product .rebuy-modal-close', function (e) {
                $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
              });
            }
          }

          if (event.detail.widget.element._prevClass == 'rebuy-cart-recommended-products') {
            var openWidgetDataX = [];
            openWidgetDataX = event.detail.widget.data.products;
            var openWidgetData = openWidgetDataX;

            openWidgetData.forEach(function (item, index) {
              if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').length > 0) {
                $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').remove();
              }
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<p class="rebuy-vendor">' + item.vendor + '</p>');

              if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-text-badges').length > 0) {
                $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-text-badges').remove();
              }
              var badge_val = '';
              var badge_color = '';
              if (item.tags.indexOf('badge_') > -1) {
                item.tags.split(', ').forEach(function (tag) {
                  if (tag.match('badge_')) {
                    var badge_ = tag.replace('badge_', '');
                    var bagde_arr = badge_.split('_');
                    badge_val = bagde_arr[0];
                    badge_color = bagde_arr[1];
                  }
                });
                $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<span class="rebuy-product-text-badges" style="background-color:' + badge_color + '">' + badge_val + '</span>');
              }

              if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-offer-badges').length > 0) {
                $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-offer-badges').remove();
              }
              if (item.selected_variant.compare_at_price > item.selected_variant.price) {
                var discountPer = Math.ceil((item.selected_variant.price - item.selected_variant.compare_at_price) / item.selected_variant.compare_at_price * 100);
                // discountPer = korting.toString().replace('-', '');                

                $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<span class="rebuy-product-offer-badges">' + discountPer + '%</span>');
              }
            });

            $('.' + event.detail.widget.element._prevClass).find('.click-rebuy').click(function (ev) {
              ev.preventDefault();

              var $thishtml = $(ev.currentTarget).siblings('button.rebuy-button').html();

              var $thisClickVar = $(ev.target);
              var curVarId = $(ev.target).parents('.rebuy-product-block').find('.rebuy-select').val();
              $(ev.currentTarget).siblings('button.rebuy-button').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

              var addCrtItem = Rebuy.widgets[0].data.products.find(function (item) {
                return parseInt(item.selected_variant_id) === parseInt(curVarId);
              });

              if ($thisClickVar.parents('.rebuy-product-block').find('form.rebuy-form').length > 0) {
                $thisClickVar.unwrap();
                $thisClickVar.siblings('input[type="hidden"]').remove();
              }

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions button, span.click-rebuy').wrapAll('<form method="post" action="/cart/add" accept-charset="UTF-8" data-product-form="" id="product_form_' + addCrtItem.id + '" enctype="multipart/form-data" data-product-id="' + addCrtItem.id + '" data-productid="' + addCrtItem.id + '" data-price="' + app._formatMoney(addCrtItem.selected_variant.price) + '" class="restock-form position-relative rebuy-form" data-hawkid="' + addCrtItem.selected_variant_id + '">');

              if (addCrtItem.product_type == 'Hornos') {
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<div data-install="product_installation_horno-elite-touch-instalacion" class="has_installation"><input type="hidden" name="installation" value="yes"></div>');
              }

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[weight]" value="' + addCrtItem.selected_variant.weight + '">');

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[tags]" value="' + addCrtItem.tags.replace(/, /g, ',') + '">');

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[sku]" value="' + addCrtItem.selected_variant.sku + '">');

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[inventory]" value="' + addCrtItem.selected_variant.inventory_quantity + '">');

              if (event.detail.widget.element._prevClass == 'rebuy-cart-recommended-products') {
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_attribution]" value="Rebuy cart-recommended">');
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_widget_id]" value="' + event.detail.widget.id + '">');
              }

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_source]" value="Rebuy">');

              var tempArray1 = addCrtItem;
              var array1 = [];

              tempArray1.properties = { 'tags': addCrtItem.tags.replace(/, /g, ','), 'sku': addCrtItem.selected_variant.sku, 'inventory': addCrtItem.selected_variant.inventory_quantity, 'weight': parseInt(addCrtItem.selected_variant.weight) };
              tempArray1.variant_id = addCrtItem.selected_variant_id;

              array1.push(tempArray1);

              var contains = { items: array1 };

              if (app.selectedRegion != null) {
                var valReg = app.selectedRegion;
              } else {
                var valReg = $('[data-regions]').val();
              }

              if (app.selectedComuna != null) {
                var valCom = app.selectedComuna;
              } else {
                var valCom = $('[data-district]').val();
              }

              if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
                var _data = {
                  location_id: 'null',
                  shipping_type: 'delivery',
                  region: valReg,
                  district: valCom,
                  cart: JSON.stringify(contains),
                  date_count: 1,
                  change_shipping_type: 0
                };

                if (app.freeShippingEnabled) {
                  var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
                } else {
                  var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
                }

                $.ajax({
                  type: 'POST',
                  url: ajax_url,
                  dataType: 'json',
                  data: _data,
                  success: function success(data) {

                    data.forEach(function (item, index) {
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_type]" value="' + item.type + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_price]" value="' + item.shipping_price + '">');
                      if (item.type == 'preorder') {
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.start_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                      } else if (item.type == 'marketplace') {
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.delivery_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                      } else {
                        if (item.type == 'pickup') {
                          var ship_pick_dates = item.pickup_dates;
                        } else {
                          var ship_pick_dates = item.shipping_dates;
                        }

                        var dileveryDate = [];
                        var getMonth = '';
                        var firstDate = '';
                        var firstFullfillDate = '';

                        var count = 0;
                        $.each(ship_pick_dates, function (shipping_date) {
                          if (count == 0) {
                            getMonth = shipping_date;
                            firstDate = shipping_date;
                            firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                          }
                          if (count < 10) {
                            dileveryDate.push(shipping_date);
                          }
                          count = count + 1;
                        });
                        getMonth = getMonth.split('-')[1];
                        if (item.type == 'pickup') {} else {
                          $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + firstDate + '">');
                          $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + firstFullfillDate + '">');
                        }
                      }

                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_store]" value="">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_storeid]" value="">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pick_available]" value="false">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pickup_date]" value="">');
                    });

                    setTimeout(function () {
                      app._addToCart(curVarId, ev);
                      $(ev.currentTarget).siblings('button.rebuy-button').html($thishtml);
                    }, 2000);
                  }
                });
              }
            });
          }
        });
      }

      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        if (app.currentTemplate == 'product') {
          setTimeout(function () {
            $('.button-overlay').addClass('d-none');
          }, 4500);
        }
      }

      /*  add this code once smart cart is on  */
      document.addEventListener('rebuy:smartcart.ready', function (event) {
        // If your shop already uses jquery, no need to use 'Rebuy.libaries.$', feel free to replace this with '$'
        Rebuy.libraries.$('.cart-icon').click(function () {
          // show Smart Cart once the icon is clicked
          Rebuy.SmartCart.show();
        });

        $('body').on('click', '.rebuy-cart__flyout-item-remove', function (event) {
          $(event.currentTarget).find('i').removeClass('fa-trash').addClass('fa-sync-alt fa-fast-spin');
          var rebuyItemIndex = $(event.currentTarget).parents('.rebuy-cart__flyout-item').index();
          $('.cart-drawer [data-cart-item]:eq(' + rebuyItemIndex + ') .icon-close_kc.text-danger').trigger('click');
          $('.cart-drawer [data-cart-item]:eq(' + rebuyItemIndex + ') .icon-close_kc.text-danger')[0].click();
          setTimeout(function () {
            $(event.currentTarget).find('i').removeClass('fa-sync-alt fa-fast-spin').addClass('fa-trash');
          }, 1000);
        });

        $('body').on('click', '.rebuy-cart__flyout-decrease', function (event) {
          $(event.currentTarget).find('i').removeClass('fa-minus').addClass('fa-sync-alt fa-fast-spin');
          var rebuyItemIndex = $(event.currentTarget).parents('.rebuy-cart__flyout-item').index();
          $('.cart-drawer [data-cart-item]:eq(' + rebuyItemIndex + ') [data-qty-decrease]')[0].click();
          setTimeout(function () {
            $(event.currentTarget).find('i').removeClass('fa-sync-alt fa-fast-spin').addClass('fa-minus');
          }, 1000);
        });
        $('body').on('click', '.rebuy-cart__flyout-increase', function (event) {
          $(event.currentTarget).find('i').removeClass('fa-plus').addClass('fa-sync-alt fa-fast-spin');
          var rebuyItemIndex = $(event.currentTarget).parents('.rebuy-cart__flyout-item').index();
          $('.cart-drawer [data-cart-item]:eq(' + rebuyItemIndex + ') [data-qty-increase]')[0].click();
          setTimeout(function () {
            $(event.currentTarget).find('i').removeClass('fa-sync-alt fa-fast-spin').addClass('fa-plus');
          }, 1000);
        });
      });
    },
    _ALAcheckFlickity: function _ALAcheckFlickity() {
      var isALARendered = setInterval(function () {
        if (app.currentTemplate == 'collection' || app.currentTemplate == 'search') {
          if ($('.category-img-filter .row .category-img-div').length > 0) {
            if ($(window).width() > 991) {
              var initIndex = 3;
            } else {
              var initIndex = 1;
            }
            var flkty1 = new Flickity('.category-img-filter .row');
            flkty1.destroy();
            var flkty = new Flickity('.category-img-filter .row', {
              adaptiveHeight: false,
              contain: true,
              // cellAlign: 'center',
              // wrapAround: true,
              groupCells: false,
              accessibility: true,
              prevNextButtons: true,
              pageDots: false,
              lazyLoad: true,
              initialIndex: initIndex,
              // resize:true,
              arrowShape: { x0: 10, x1: 60, y1: 45, x2: 60, y2: 35, x3: 20 },
              on: {
                ready: function ready() {
                  $('.category-img-filter .flickity-button.previous').attr('disabled', 'disabled');
                  if ($('.category-img-filter .category-img-div').length < 8) {
                    $('.category-img-filter .flickity-button.next').attr('disabled', 'disabled');
                  }
                }
              }
            });
            flkty.resize();
            flkty.on('change', function (index) {
              var tot_length = $('.category-img-filter .category-img-div').length;
              var hide_last = parseInt(tot_length) - index;

              if (index < 4 && window.innerWidth >= 768) {
                $('.category-img-filter .flickity-button.previous').attr('disabled', 'disabled');
              } else if (index < 2 && window.innerWidth < 768) {
                $('.category-img-filter .flickity-button.previous').attr('disabled', 'disabled');
              } else {
                $('.category-img-filter .flickity-button.previous').removeAttr('disabled');
              }

              if (hide_last <= 4 && window.innerWidth >= 768) {
                $('.category-img-filter .flickity-button.next').attr('disabled', 'disabled');
              } else if (hide_last <= 2 && window.innerWidth < 768) {
                $('.category-img-filter .flickity-button.next').attr('disabled', 'disabled');
              } else {
                $('.category-img-filter .flickity-button.next').removeAttr('disabled');
              }
            });
            $('.category-img-filter').css('opacity', 1);

            clearInterval(isALARendered);
          }
        }
      }, 200);
    },
    _openInstallProdModal: function _openInstallProdModal(event) {
      $('#modalpdp').modal('show');
      $('#app').addClass('show-ins-overlay');
    },
    _hideInstallProdModal: function _hideInstallProdModal(event) {
      $('#modalpdp').modal('hide');
      $('#app').removeClass('show-ins-overlay');
    },
    _addInstallation: function _addInstallation(event) {
      if (app.currentTemplate == 'product') {
        $('#modalpdp').modal('hide');
        $('#app').removeClass('show-ins-overlay');
        // $('.product_install').trigger('click');
        $('.product_install').prop('checked', true).trigger('change');
        app.installProductHandle = $('.installation-service .product_install').data('product-handle');
        app.installVariantId = $('.installation-service .product_install').data('installvariant-id');
        app.installProdTags = $('.installation-service .product_install').data('product-tags');
        // $('.installation-service label').removeClass('disable');
      }
    },


    // eslint-disable-next-line require-await
    _openmodel: function _openmodel(itemId, insItemId, insTags, random_no) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var InstPrdDetails, chck_instObj, itemModalImg;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (app.currentTemplate == 'cart') {
                  InstPrdDetails = {};

                  InstPrdDetails.main_prod = itemId;
                  InstPrdDetails.ins_prod = insItemId;
                  InstPrdDetails.tags = insTags.toString();
                  InstPrdDetails.tags = InstPrdDetails.tags.replace(',', ', ');

                  chck_instObj = app.cart.items.find(function (item) {
                    return item.variant_id === itemId;
                  });


                  InstPrdDetails.random_prop = random_no;
                  InstPrdDetails.quantity = chck_instObj.quantity;
                  if (chck_instObj.itemMetafieldsInstall.install_service_info && chck_instObj.itemMetafieldsInstall.install_service_info != '') {
                    InstPrdDetails.install_service_info = chck_instObj.itemMetafieldsInstall.install_service_info;
                  } else if (chck_instObj.itemMetafieldsInstall.grill_service_info && chck_instObj.itemMetafieldsInstall.grill_service_info != '') {
                    InstPrdDetails.grill_service_info = chck_instObj.itemMetafieldsInstall.grill_service_info;
                  }
                  itemModalImg = [];

                  if (chck_instObj.itemMetafieldsInstall.specification_img) {
                    itemModalImg = chck_instObj.itemMetafieldsInstall.specification_img.split(',');
                    itemModalImg.forEach(function (imag) {
                      InstPrdDetails.specification_img = itemModalImg;
                    });

                    app.InstPrdDetails.specification_img = chck_instObj.itemMetafieldsInstall.specification_img;
                  }

                  app.InstPrdDetails = InstPrdDetails;
                  $('#app').addClass('show-ins-overlay');
                  $(app.cart.items).each(function (_index, item) {
                    if (item.product_type == 'Hornos' || item.product_type == 'Grill assembly') {
                      $(item.productInstallTags).each(function (_i, tags) {
                        if (tags.name == 'installProductVariants') {
                          var _itemModalImg = [];
                          if (tags.metafield.specification_img) {
                            _itemModalImg = tags.metafield.specification_img.split(',');
                            _itemModalImg.forEach(function () {
                              app.itemModalImg = _itemModalImg;
                            });
                          }
                        }
                      });
                    }
                  });

                  setTimeout(function () {
                    $('[data-accept-terms]').on('change', function (event) {
                      if ($(event.currentTarget).parents('.pdp-modal').find('input[name="accept_terms"]').is(':checked')) {
                        app.isTermsChecked = true;
                      } else {
                        app.isTermsChecked = false;
                      }
                    });
                  }, 1000);
                  $('#accept_terms').prop('checked', false);
                  app.isTermsChecked = false;
                  $('#modalpdp').modal('show');
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    _openGrillProdModal: function _openGrillProdModal(event) {
      $('#modalpdpgrill').modal('show');
      $('#app').addClass('show-grill-overlay');
    },
    _hideGrillProdModal: function _hideGrillProdModal(event) {
      $('#modalpdpgrill').modal('hide');
      $('#app').removeClass('show-grill-overlay');
    },
    _addGrillAsembly: function _addGrillAsembly(event) {
      if (app.currentTemplate == 'product') {
        $('#modalpdpgrill').modal('hide');
        $('#app').removeClass('show-grill-overlay');
        $('.product_grill').prop('checked', true).trigger('change');
        app.grillProductHandle = $('.grill-service .product_grill').data('product-handle');
        app.grillVariantId = $('.grill-service .product_grill').data('grillvariant-id');
        app.grillProdTags = $('.grill-service .product_grill').data('product-tags');
      }
    },
    _changeImage: function _changeImage() {
      if (app.currentTemplate === 'product') {
        $('.color input').on('change', function (event) {
          var val = $(event.currentTarget).val();
          var appendAllNav = '';
          var appendAllMain = '';
          $('[data-image-change]').css('opacity', '0');
          var flkty1 = new Flickity('[data-carousel-nav]'); // init flickity
          var flkty2 = new Flickity('[data-carousel-main]'); // init flickity
          $('[data-thumbs]').each(function (index) {
            var imgAlt = $(this).attr('data-variant-title');
            if (val == imgAlt) {
              appendAllNav += $(this).html();
            }
            if (imgAlt.indexOf('@https') > -1) {
              appendAllNav += $(this).html();
            }
          });

          $('[data-thumbs-main]').each(function (index) {
            var imgAlt = $(this).attr('data-variant-title');
            if (val == imgAlt) {
              appendAllMain += $(this).html();
            }
            if (imgAlt.indexOf('@https') > -1) {
              appendAllMain += $(this).html();
            }
          });

          flkty1.destroy();
          $('[data-carousel-nav]').removeClass('flickity-enabled').empty();
          flkty2.destroy();
          $('[data-carousel-main]').removeClass('flickity-enabled is-draggable').empty();

          if ($.trim(appendAllMain) == '') {
            $('[data-thumbs-main]').each(function () {
              $('[data-carousel-main]').append($(this).html());
            });
          } else {
            $('[data-carousel-main]').html(appendAllMain);
          }

          if ($.trim(appendAllNav) == '') {
            $('[data-thumbs]').each(function () {
              $('[data-carousel-nav]').append($(this).html());
            });
          } else {
            $('[data-carousel-nav]').html(appendAllNav);
          }

          var flkty3 = new Flickity('[data-carousel-nav]', {
            asNavFor: '.carousel-main',
            draggable: false,
            percentPosition: false,
            cellAlign: 'center',
            groupCells: '100%',
            prevNextButtons: false,
            pageDots: false
          });

          var flkty4 = new Flickity('[data-carousel-main]', {
            contain: true,
            wrapAround: false,
            draggable: false,
            setGallerySize: true,
            prevNextButtons: true,
            fullscreen: true,
            lazyLoad: true,
            pageDots: true,
            arrowShape: { x0: 10, x1: 60, y1: 45, x2: 60, y2: 35, x3: 20 }
          });
          $('[data-image-change]').css('opacity', '1');
        });
      }
    },
    _alternateHome: function _alternateHome(event, url) {
      if ($('.alternateHome__collection--item').length) {
        app.loading = true;
        app.collection.products = [];
        $(event.currentTarget).closest('.alternateHome__collection--item').addClass('is-selected-div').siblings().removeClass('is-selected-div');
        var coll_name = $(event.currentTarget).closest('.alternateHome__collection--item').find('[data-coll-name]').html();
        $('.collection_name').html(coll_name);
        if ($('.cyber-banner-img').length) {
          var currentTargetName = $(event.currentTarget).attr('name');
          $('.cyber-banner-img').each(function () {
            var banner_name = $(this).attr('name');
            if (banner_name == currentTargetName) {
              $(this).addClass('d-block is-selected-div').siblings().removeClass('d-block is-selected-div');
            }
          });
        }

        if (url.indexOf('?') > -1) {
          url += '&view=products.json';
        } else {
          url += '?view=products.json';
        }
        axios.get(url).then(function (response) {
          var productsData = [];
          response.data.products.forEach(function (item) {
            var product = item.product;

            // add default current_variant object
            product.current_variant = product.variants[0];

            // add product options
            product.options_with_values = item.options_with_values;
            product.timer = null;
            product.saving = Math.round(product.compare_at_price_max - product.price);

            var discount = (product.compare_at_price_max - product.price) / product.compare_at_price_max * 100;
            discount = discount.toString().split('.')[0];
            discount = discount.toString().replace('-', '');
            product.discount = discount + "%";

            // add cart limit tag
            product.tags.forEach(function (tag) {
              if (tag.match('cart-limit')) {
                var cartLimit = tag.replace('cart-limit-', '');
                product.cart_limit = parseFloat(cartLimit);
              }
              if (tag.match('badge_')) {
                var badge_ = tag.replace('badge_', '');
                product.badge = badge_;
                var bagde_arr = badge_.split('_');
                product.badge_val = bagde_arr[0];
                product.badge_color = bagde_arr[1];
              }
              if (tag.match('timer_')) {
                var timer = tag.replace('timer_', '');
                timer = timer.replace('/', ', ');
                product.timer = timer;
                var productTimerDate = product.timer;
                var newproductTimerDate = new Date(productTimerDate);
                var countProductDate = new Date(newproductTimerDate).getTime();

                var x = setInterval(function () {
                  var now = new Date().getTime();
                  var productDateRemaining = countProductDate - now;

                  if (productDateRemaining > 0) {
                    var days = Math.floor(productDateRemaining / (1000 * 60 * 60 * 24));
                    var hours = Math.floor(productDateRemaining % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
                    var minutes = Math.floor(productDateRemaining % (1000 * 60 * 60) / (1000 * 60));
                    var seconds = Math.floor(productDateRemaining % (1000 * 60) / 1000);
                    var html = "<ul class=\"vuejs-countdown\"><li><p class=\"digit\">" + days + "</p><p class=\"text\">dias</p></li>" + ("<li><p class=\"digit\">" + hours + "</p><p class=\"text\">horas</p></li>") + ("<li><p class=\"digit\">" + minutes + "</p><p class=\"text\">min</p></li>") + ("<li><p class=\"digit\">" + seconds + "</p><p class=\"text\">segs</p></li></ul>");
                    $("[data-product=\"" + product.id + "\"]").html(html);
                  }
                }, 1000);
              }
            });

            // exclude products that have the app.productExcludeTag (theme settings)
            if (product.tags.indexOf(app.productExcludeTag) === -1) {
              productsData.push(product);
            }
          });

          app.collection.products = productsData;
          app.isLoading = false;
          // return response;
        }).catch(function (error) {
          throw error;
        });

        if (url.indexOf('view=paginate.json') > -1) {
          url = url.replace('&view=paginate.json', '');
        }
        url += '&view=paginate.json';

        axios.get(url)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          app.collection.pagination = response.data;
          // return response;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _validateEmail: function _validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    _getComparePro: function _getComparePro() {
      var availableProducts = localStorage.getItem('compareProducts');
      app.comparePropArray = [];
      app.iscompareLoaded = false;
      if (availableProducts !== undefined && availableProducts !== null && availableProducts.length > 0) {
        app.compareProducts = availableProducts.split(',');
        $('[name="compare_product"]').prop('checked', false);
        $(app.compareProducts).each(function (index, handle) {
          $("[name=\"compare_product\"][value=\"" + handle + "\"]").prop('checked', true);

          axios.get("/products/" + handle + "?view=json")
          // eslint-disable-next-line promise/always-return
          .then(function (response) {
            app.comparePropArray.push(response.data);
          }).catch(function (error) {
            console.log(error);
            throw error;
          });
        });
        setTimeout(function () {
          app.iscompareLoaded = true;
          if (app.currentTemplate === 'product') {
            $('[data-compareModal]').addClass('show');
          }
        }, 1000);
      } else {
        $('[data-compareModal]').removeClass('show');
        $('[name="compare_product"]').prop('checked', false);
        app.iscompareLoaded = true;
      }
    },
    _compareProUpdate: function _compareProUpdate(event, handle) {
      var $target = $(event.currentTarget);
      if ($target.prop('checked') === true) {
        app._addCompareProduct(handle);
      } else {
        app._removeCompareProduct(handle);
      }
    },
    _addCompareProduct: function _addCompareProduct(product) {
      var availableProducts = localStorage.getItem('compareProducts');
      if (availableProducts !== undefined && availableProducts != null) {
        app.compareProducts = availableProducts.split(',');
        if (app.compareProducts.length < 3) {
          availableProducts += "," + product;
        } else {
          $("[name=\"compare_product\"][value=\"" + product + "\"]").prop('checked', false);
          app._snotifyMessage('Only 3 products allowed!', 'Product Limit');
        }
      } else {
        availableProducts = product;
      }
      app.compareProducts = availableProducts.split(',');
      localStorage.setItem('compareProducts', availableProducts);
      app._getComparePro();
    },
    _removeCompareProduct: function _removeCompareProduct(handle) {
      app.iscompareLoaded = false;
      var availableProducts = localStorage.getItem('compareProducts');
      if (availableProducts !== undefined && availableProducts !== null) {
        if (availableProducts.indexOf(handle + ",") > -1) {
          availableProducts = availableProducts.replace(handle + ",", '');
        } else if (availableProducts.indexOf("," + handle) > -1) {
          availableProducts = availableProducts.replace("," + handle, '');
        } else {
          availableProducts = availableProducts.replace("" + handle, '');
        }
        if (availableProducts.length > 0) {
          app.compareProducts = availableProducts.split(',');
          localStorage.setItem('compareProducts', availableProducts);
        } else {
          app.compareProducts = [];
          localStorage.removeItem('compareProducts');
        }
        app._getComparePro();
      }
    },
    _clearcompare: function _clearcompare() {
      localStorage.removeItem('compareProducts');
      app._getComparePro();
    },
    _selectWarranty: function _selectWarranty(event, id) {
      var $target = $(event.currentTarget);
      if ($target.prop('checked') === true) {
        app.WarrantyProductsHandle = $target.val();
        app.WarrantyVariantID = id;
      }
    },
    _scrollColl: function _scrollColl() {
      var $target = $('.home_collections');
      $('html, body').animate({
        scrollTop: $target.offset().top - $('.collections-group').innerHeight()
      }, 'fast');
    },
    _klaviyoSubscription: function _klaviyoSubscription() {
      $('body').on('click', '[data-subscribeFormButton]', function (event) {
        var $this = $(event.currentTarget);
        var $form = $this.closest('form');
        var email = $.trim($form.find('[data-mailId]').val());
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var error_msg = $form.find('[data-subscribe-error]');

        if (email.length > 0) {
          if (app._validateEmail(email)) {
            $form.find('[data-formSubmit]').click();
          } else {
            $('[data-klaviyo_messages]').show();
            error_msg.html('Provide Valid details.').css('opacity', '1').show();
            setTimeout(function () {
              error_msg.css('opacity', '0').hide();
              $('[data-klaviyo_messages]').hide();
            }, 3000);
          }
        } else {
          $('[data-klaviyo_messages]').show();
          error_msg.html('Email no puede estar en blanco').css('opacity', '1').show();
          setTimeout(function () {
            error_msg.css('opacity', '0').hide();
            $('[data-klaviyo_messages]').hide();
          }, 3000);
        }
      });
    },
    _projectSlider: function _projectSlider() {
      if ($('[data-accordian]').length) {
        if (matchMedia('screen and (max-width: 767px)').matches) {
          var $carousel = $('[data-accordian]');
          if ($carousel.length > 0) {
            var options = {
              adaptiveHeight: true,
              contain: true,
              wrapAround: false,
              freeScroll: false,
              accessibility: true,
              setGallerySize: true,
              prevNextButtons: false,
              pageDots: false,
              groupCells: '100%',
              draggable: true,
              dragThreshold: 20,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 45,
                x3: 15
              }
            };
            var flkty = new Flickity($carousel[0], options);
          }
        }
      }

      if ($('[data-benefits-carousel]').length) {
        if (matchMedia('screen and (max-width: 991px)').matches) {
          var _$carousel = $('[data-benefits-carousel]');
          if (_$carousel.length > 0) {
            var _options = {
              adaptiveHeight: true,
              contain: true,
              wrapAround: false,
              freeScroll: false,
              accessibility: true,
              setGallerySize: true,
              prevNextButtons: true,
              pageDots: false,
              groupCells: true,
              draggable: true,
              dragThreshold: 20,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 45,
                x3: 15
                // eslint-disable-next-line comma-dangle
              }
            };
            var _flkty = new Flickity(_$carousel[0], _options);
          }
        }
      }
    },
    _kitchenboxSlider: function _kitchenboxSlider() {
      if ($('[data-kitchenBox]').length) {
        if (matchMedia('screen and (max-width: 767px)').matches) {
          var $carousel = $('[data-kitchenBox]');
          var options = {
            adaptiveHeight: false,
            contain: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: true,
            groupCells: '100%',
            draggable: true,
            lazyLoad: true,
            dragThreshold: 20,
            arrowShape: {
              x0: 10,
              x1: 60,
              y1: 50,
              x2: 60,
              y2: 45,
              x3: 15
            }
          };
          var flkty = new Flickity($carousel[0], options);
        }
      }
    },
    _megaMenu: function _megaMenu() {
      $('.megamenu-category-name #pills-tab li:first-child').addClass('active megamenu-arrow');

      // Click function
      $('#pills-tab li').mouseenter(function () {
        $('#pills-tabContent .tab-content').show();
        $('#pills-tab li').removeClass('active');
        $('#pills-tab li').removeClass('megamenu-arrow');
        $('#pills-tab li .menu-img img').removeClass('opacity-active');
        $(this).addClass('active');
        $(this).addClass('megamenu-arrow');
        $(this).find('.menu-img img').addClass('opacity-active');

        var activeTab = $(this).data('tab');
        $(activeTab).show();
        return false;
      });

      $('#accordion').find('.card-heading').click(function (event) {
        $('.card .card-heading').removeClass('active');
        $('.card .card-heading img.mobilemenu-img').removeClass('opacity-active');
        $(event.currentTarget).find('img.mobilemenu-img').addClass('opacity-active');
      });
    },
    _viewmore: function _viewmore() {
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    },
    _cyberMenu: function _cyberMenu() {
      $('.cyber-menu-toggle').click(function () {
        $('.cyber-mobile-nav').addClass('d-block');
      });
      $('.alternateHome__collection--item').click(function () {
        $('.cyber-mobile-nav-close').click();
      });
      $('.cyber-mobile-nav-close').click(function () {
        $('.cyber-mobile-nav').removeClass('d-block');
      });
    },
    _collectionFilter: function _collectionFilter() {
      $('.mobile_filter .filter--toggle').click(function (e) {
        $('.shop_filters').addClass('side_toggle');
        $('body').addClass('body_overlay');
      });
      $('.back_clear .back_arrow').click(function (e) {
        $('.shop_filters').removeClass('side_toggle');
        $('body').removeClass('body_overlay');
      });
      $('.shop_filters .tag-filter h5, .shop_filter .tag-filter h5').each(function (index, element) {
        $(this).click(function (e) {
          $(this).parent().siblings().find('ul').slideUp('fast');
          $(this).parent().find('ul').slideToggle('fast');
          $(this).toggleClass('active');
          $(this).parents('.tag-filter').siblings().children('h5').removeClass('active');
        });
      });
      $('html').click(function () {
        $('.sidebar-tag').slideUp('fast');
        $('.shop_filter .tag-filter h5').removeClass('active');
      });
      $('.shop_filter .tag-filter h5, .sidebar-tag').click(function (e) {
        e.stopPropagation();
      });

      $('body').on('click', '[data-quick-tagremove]', function () {
        var tagName = $(this).data('tag');
        $("label[for=\"" + tagName + "\"]").trigger('click');
      });

      $('[data-category-label]').on('click', function () {
        var current_index = $('[data-category-label]').index(this);
        $('[data-type="category"]').each(function (index, value) {
          if (index !== current_index) {
            if ($(this).is(':checked')) {
              $(this).prop('checked', false);
            }
          }
        });
      });

      $('[data-edit-profile]').click(function (e) {
        e.preventDefault();
        if ($(e.currentTarget).hasClass('active')) {
          $(e.currentTarget).removeClass('active');
          $('.display-text').removeClass('d-none');
          $('.edit-text').addClass('d-none');
          $('.with-two-fields').addClass('d-none').removeClass('d-flex');
        } else {
          $(e.currentTarget).addClass('active');
          $('.display-text').addClass('d-none');
          $('.edit-text').removeClass('d-none');
          $('.with-two-fields').removeClass('d-none').addClass('d-flex');
        }
      });
    },
    _rutValidate: function _rutValidate(event) {
      var $current = $(event.currentTarget);
      $current.rut({
        formatOn: 'keyup',
        validateOn: 'keyup'
      }).on('rutInvalido', function () {}).on('rutValido', function () {});
    },
    _formatRUT: function _formatRUT(rutval) {
      rutval.value = rutval.value.replace(/[^0-9]/g, '').replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
    },
    _validateRegistrationForm: function _validateRegistrationForm(event) {
      var $thisform = $(event.currentTarget).closest('form');
      $('[data-error_list]').empty();
      var finalError = '';

      if ($('#customerFirstName').length && app.customerFirstName == '') {
        finalError += '<li>Nombre no puede estar en blanco</li>';
        $('#customerFirstName').addClass('border-danger');
        $('#customerFirstName').siblings('[data-error-msg]').text($('#customerFirstName').attr('data-error-blank')).removeClass('d-none');
      } else if (!$('#customerFirstName').val().match(/^[A-Za-záéñóúüÁÉÑÓÚÜ\-' ]+$/)) {
        finalError += '<li>Nombre no puede estar en blanco</li>';
        $('#customerFirstName').addClass('border-danger');
        $('#customerFirstName').siblings('[data-error-msg]').text($('#customerFirstName').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('#customerLastName').length && app.customerLastName == '') {
        finalError += '<li>Apellidos no puede estar en blanco</li>';
        $('#customerLastName').addClass('border-danger');
        $('#customerLastName').siblings('[data-error-msg]').text($('#customerLastName').attr('data-error-blank')).removeClass('d-none');
      } else if (!$('#customerLastName').val().match(/^[A-Za-záéñóúüÁÉÑÓÚÜ\-' ]+$/)) {
        finalError += '<li>Apellidos no puede estar en blanco</li>';
        $('#customerLastName').addClass('border-danger');
        $('#customerLastName').siblings('[data-error-msg]').text($('#customerLastName').attr('data-error-validate')).removeClass('d-none');
      }

      // if ($('#customerPhoneNumber').length && app.customerPhoneNumber == '') {
      //   finalError += '<li>Teléfono no puede estar en blanco</li>';
      // }
      if (app.customerPhoneNumber == '') {
        finalError += '<li>Celular no puede estar en blanco</li>';
        $('#customerPhoneNumber').addClass('border-danger');
        $('#customerPhoneNumber').parents('.form-group').addClass('error-phone');
        $('#customerPhoneNumber').siblings('[data-error-msg]').text($('#customerPhoneNumber').attr('data-error-blank')).removeClass('d-none');
      } else if (app.customerPhoneNumber.length != 9) {
        finalError += '<li>Celular no tiene la longitud correcta (8 caracteres exactos)</li>';
        $('#customerPhoneNumber').addClass('border-danger');
        $('#customerPhoneNumber').parents('.form-group').addClass('error-phone');
        $('#customerPhoneNumber').siblings('[data-error-msg]').text($('#customerPhoneNumber').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('#contactFormRut').length && app.contactFormRut == '') {
        finalError += '<li class="rut_error">Rut no puede estar en blanco</li>';
        $('#contactFormRut').addClass('border-danger');
        $('#contactFormRut').siblings('[data-error-msg]').text($('#contactFormRut').attr('data-error-blank')).removeClass('d-none');
      } else if ($('#contactFormRut').hasClass('rut-error')) {
        finalError += '<li class="rut_error">Rut no puede estar en blanco</li>';
        $('#contactFormRut').addClass('border-danger');
        $('#contactFormRut').siblings('[data-error-msg]').text($('#contactFormRut').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('#registerCustomerEmail').length && app.customerEmail == '') {
        finalError += '<li>Email no puede estar en blanco</li>';
        $('#registerCustomerEmail').addClass('border-danger');
        $('#registerCustomerEmail').siblings('[data-error-msg]').text($('#registerCustomerEmail').attr('data-error-blank')).removeClass('d-none');
      } else if (app.customerEmail != '' && !app._validateEmail(app.customerEmail)) {
        finalError += '<li>Email debe ser un email válido</li>';
        $('#registerCustomerEmail').addClass('border-danger');
        $('#registerCustomerEmail').siblings('[data-error-msg]').text($('#registerCustomerEmail').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('#registerCustomerPassword').length && app.customerPassword == '') {
        finalError += '<li>Nueva contraseña no puede estar en blanco</li>';
        $('#registerCustomerPassword').addClass('border-danger');
        $('#registerCustomerPassword').siblings('[data-error-msg]').text($('#registerCustomerPassword').attr('data-error-blank')).removeClass('d-none');
      }

      if ($('#registerConfirmCustomerPassword').length && app.confirmCustomerPassword == '') {
        finalError += '<li>Confirm Nueva contraseña no puede estar en blanco</li>';
        $('#registerConfirmCustomerPassword').addClass('border-danger');
        $('#registerConfirmCustomerPassword').siblings('[data-error-msg]').text($('#registerConfirmCustomerPassword').attr('data-error-blank')).removeClass('d-none');
      }
      if (app.confirmCustomerPassword != '' && app.ispassWordMatched == false) {
        finalError += '<li>Confirmación del Password no coincide</li>';
        $('#registerConfirmCustomerPassword').addClass('border-danger');
        $('#registerConfirmCustomerPassword').siblings('[data-error-msg]').text($('#registerConfirmCustomerPassword').attr('data-error-validate')).removeClass('d-none');
      }

      $('[data-error_list]').append(finalError);
      var error_list_li = $('[data-error_list] li').length;
      $('.error_count').text(error_list_li);

      if ($('[data-error_list] li').length > 0 || $('.rut_message').hasClass('show_rut_error')) {
        event.preventDefault();
        if ($('[data-error_list] li').length > 0) {
          // $('html, body').animate({ scrollTop: '0' });
          // $('#errorExplanation').show().fadeIn(500);
        } else {
          // $('#errorExplanation').hide().fadeOut(500);
          // $('#create_customer').submit();
          app._addCustomer($(event.currentTarget));
        }
      } else {
        $('#errorExplanation').hide().fadeOut(500);
        // $('#create_customer').submit();
        app._addCustomer($(event.currentTarget));
      }
    },
    _validateLoginForm: function _validateLoginForm(event) {
      var $this = $(event.currentTarget);
      if ($('#customerEmail').length && $('#customerEmail').val() == '') {
        $('#customerEmail').addClass('border-danger');
        $('#customerEmail').siblings('[data-error-msg]').text($('#registerCustomerEmail').attr('data-error-blank')).removeClass('d-none');
      } else if ($('#customerEmail').val() != '' && !app._validateEmail($('#customerEmail').val())) {
        $('#customerEmail').addClass('border-danger');
        $('#customerEmail').siblings('[data-error-msg]').text($('#customerEmail').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('#customerPassword').length && $('#customerPassword').val() == '') {
        $('#customerPassword').addClass('border-danger');

        if ($('#customerPassword').is(':visible')) {
          $('#customerPassword').siblings('[data-error-msg]').text($('#customerPassword').attr('data-error-blank')).removeClass('d-none');
        }
      }

      if (!$this.hasClass('login-validate')) {
        $('#customer_login').submit();
      }
    },
    _validateAddressForm: function _validateAddressForm(event) {
      var $this = $(event.currentTarget);
      var $thisform = $(event.currentTarget).parents('form');
      $thisform.find('input[type="text"],select').each(function () {
        if ($(this).val() == '' || $(this).val() == null) {
          if ($(this).attr('name') != 'address[address2]') {
            $(this).addClass('border-danger');
            $(this).siblings('[data-error-msg]').text($(this).attr('data-error-blank')).removeClass('d-none');
          }
        } else {
          if ($(this).attr('name') == 'address[address1]') {
            if (!/\d/.test($(this).val())) {
              $(this).addClass('border-danger');
              $(this).siblings('[data-error-msg]').text($(this).attr('data-error-validate')).removeClass('d-none');
            } else {
              $(this).removeClass('border-danger');
              $(this).siblings('[data-error-msg]').text('').addClass('d-none');
            }
          }
        }
      });

      if ($thisform.find('.border-danger').length == 0) {
        $thisform.submit();
      }
    },
    _onblurCheckValidation: function _onblurCheckValidation(event) {
      var $this = $(event.currentTarget);
      var $thisval = $(event.currentTarget).val();
      var thisErrorBlank = $(event.currentTarget).attr('data-error-blank');
      var thisErrorValid = $(event.currentTarget).attr('data-error-validate');
      if ($thisval == '') {
        $this.addClass('border-danger');
        $this.siblings('[data-error-msg]').text(thisErrorBlank).removeClass('d-none');
        $this.removeClass('rut-error');
        if ($this.attr('id') == 'customerPhoneNumber') {
          $this.parents('.form-group').addClass('error-phone');
        }
        $this.parents('#customerLoginForm').find('[data-login-register]').addClass('login-validate');
      } else {
        if ($this.attr('id') == 'customerFirstName' || $this.attr('id') == 'customerLastName') {
          if (!$thisval.match(/^[A-Za-záéñóúüÁÉÑÓÚÜ\-' ]+$/)) {
            $this.addClass('border-danger');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
          } else {
            $this.removeClass('border-danger');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
          }
        }

        if ($this.attr('id') == 'customerPhoneNumber') {
          if ($thisval.replace(/\s/g, '').length != 9) {
            $this.addClass('border-danger');
            $this.parents('.form-group').addClass('error-phone');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
          } else {
            $this.removeClass('border-danger');
            $this.parents('.form-group').removeClass('error-phone');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
          }
        }

        if ($this.attr('id') == 'contactFormRut') {
          if ($this.hasClass('rut-error')) {
            $this.addClass('border-danger');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
          } else {
            $this.removeClass('border-danger');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
          }
        }

        if ($this.attr('id') == 'registerCustomerEmail' || $this.attr('id') == 'customerEmail') {
          if (!app._validateEmail($thisval)) {
            $this.addClass('border-danger');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
            $this.parents('#customerLoginForm').find('[data-login-register]').addClass('login-validate');
          } else {
            $this.removeClass('border-danger');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
            if (!$('#customerPassword').hasClass('border-danger')) {
              $this.parents('#customerLoginForm').find('[data-login-register]').removeClass('login-validate');
            }
          }
        }

        if ($this.attr('id') == 'registerCustomerPassword' || $this.attr('id') == 'customerPassword' || $this.attr('name') == 'address[company]') {
          $this.removeClass('border-danger');
          $this.siblings('[data-error-msg]').text('').addClass('d-none');
          if (!$('#customerEmail').hasClass('border-danger')) {
            $this.parents('#customerLoginForm').find('[data-login-register]').removeClass('login-validate');
          }
        }

        if ($this.attr('id') == 'registerConfirmCustomerPassword') {
          if (app.ispassWordMatched == false) {
            $this.addClass('border-danger');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
            $('#registerCustomerPassword').siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
          } else {
            $this.removeClass('border-danger');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
            $('#registerCustomerPassword').siblings('[data-error-msg]').text('').addClass('d-none');
          }
        }

        if ($this.attr('name') == 'address[address1]') {
          if (!/\d/.test($this.val())) {
            $this.addClass('border-danger');
            $this.siblings('[data-error-msg]').text(thisErrorValid).removeClass('d-none');
          } else {
            $this.removeClass('border-danger');
            $this.siblings('[data-error-msg]').text('').addClass('d-none');
          }
        }
      }
    },
    _hideWarning: function _hideWarning(event) {
      var $thisform = $(event.currentTarget).closest('form');
      if ($thisform.find('.alert-warning').hasClass('alert-custom') || $thisform.find('.alert-warning').hasClass('alert-custom-success') || $(event.currentTarget).parents('[data-wrap]').find('.alert-warning').hasClass('alert-order') || $(event.currentTarget).parents('[data-wrap]').find('.alert-warning').hasClass('alert-invoice')) {
        $thisform.find('.alert-warning').removeClass('d-flex').addClass('d-none');
        $(event.currentTarget).parents('[data-wrap]').find('.alert-warning').removeClass('d-flex').addClass('d-none');
      } else {
        $thisform.find('.alert-warning').hide();
        $(event.currentTarget).parents('[data-wrap]').find('.alert-warning').hide();
      }
    },
    _addCustomer: function _addCustomer(event) {
      app.isLoading = true;
      var customerData = {};
      customerData.first_name = $('#customerFirstName').val();
      customerData.last_name = $('#customerLastName').val();
      customerData.email = $('#registerCustomerEmail').val();
      customerData.phone = '+56' + $('#customerPhoneNumber').val();
      customerData.verified_email = true;
      customerData.password = $('#registerCustomerPassword').val();
      customerData.password_confirmation = $('#registerConfirmCustomerPassword').val();
      customerData.send_email_welcome = true;
      customerData.tags = "rut_" + $('#contactFormRut').val();

      var config = JSON.stringify({
        url: '/customers.json',
        method: 'POST',
        data: {
          customer: customerData
        }
      });
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.addEventListener('load', function () {
        var response = JSON.parse(xhr.responseText);
        console.log(response);
        app.isLoading = false;
        if (response.customer && response.customer.email != '') {
          app._snotifyMessageSuccess('Success', '¡Registrado correctamente!');
          $('.custom_login').find('#customerEmailRed').val($('#registerCustomerEmail').val());
          $('.custom_login').find('#customerPasswordRed').val($('#registerCustomerPassword').val());
          setTimeout(function () {
            $('.custom_login').submit();
          }, 300);
          // document.location.href = '/account';
        } else {
          if (response.errors && response.errors.email && response.errors.email[0] == 'has already been taken') {
            // app._snotifyMessage('Error', 'El correo ya a sido recibido!');
            $('#registerCustomerEmail').siblings('[data-error-msg]').text($('#registerCustomerEmail').attr('data-error-already')).removeClass('d-none');
          } else if (response.errors && response.errors.phone && response.errors.phone[0] == 'Phone has already been taken') {
            // app._snotifyMessage('Error', 'El teléfono ya ha sido tomado!');
            $('#customerPhoneNumber').siblings('[data-error-msg]').text($('#customerPhoneNumber').attr('data-error-already')).removeClass('d-none');
          } else if (response.errors && response.errors.phone && response.errors.phone[0] == 'Enter a valid phone number to use this delivery method') {
            // app._snotifyMessage('Error', 'Introduce un número de teléfono válido!');
            $('#customerPhoneNumber').siblings('[data-error-msg]').text($('#customerPhoneNumber').attr('data-error-validate')).removeClass('d-none');
          } else {
            app._snotifyMessage('Error', 'Algo está mal!');
          }
        }
      });
      xhr.open('POST', '/tools/ha-api/shopify/common');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(config);
    },
    _validateProductNotWork: function _validateProductNotWork(event) {
      var $thisform = $(event.currentTarget).closest('form');
      $('[data-error_list]').empty();
      var finalError = '';
      if ($('#contactFormName').length && app.contactFormName == '') {
        finalError += '<li>Nombre no puede estar en blanco</li>';
      }
      if ($('#contactFormRut').length && app.contactFormRut == '') {
        finalError += '<li class="rut_error">Rut no puede estar en blanco</li>';
      }
      var rut_val = $.trim(app.contactFormRut);
      if (app.contactFormRut != '' && !isRutValid(rut_val)) {
        finalError += '<li>Rut debe ser un rut válido</li>';
      }
      if ($('#contactFormEmail').length && app.contactFormEmail == '') {
        finalError += '<li>Email no puede estar en blanco</li>';
      }
      if (app.contactFormEmail != '' && !app._validateEmail(app.contactFormEmail)) {
        finalError += '<li>Email debe ser un email válido</li>';
      }
      if ($('#contactFormPhone').length && app.contactFormPhone == '') {
        finalError += '<li>Teléfono no puede estar en blanco</li>';
      }
      if ($('#contactFormMessage').length && app.contactFormMessage == '') {
        finalError += '<li>Mensaje no puede estar en blanco</li>';
      }
      if ($('#contactFormCategory').length && app.contactFormCategory == '') {
        finalError += '<li>Categoría no puede estar en blanco</li>';
      }
      if ($('#contactFormModel').length && app.contactFormModel == '') {
        finalError += '<li>Modelo no puede estar en blanco</li>';
      }
      if ($('#contactFormstate').length && app.contactFormstate == '') {
        finalError += '<li>Región no puede estar en blanco</li>';
      }
      if ($('#contactFormCountry').length && app.contactFormCountry == '') {
        finalError += '<li>Comuna no puede estar en blanco</li>';
      }
      if ($('#contactFormAddress').length && app.contactFormAddress == '') {
        finalError += '<li>Dirección no puede estar en blanco</li>';
      }
      if ($('#contactFormOrderNo').length && app.contactFormOrderNo == '') {
        finalError += '<li>Numero de Boleta/Factura no puede estar en blanco</li>';
      }
      if (app.contactFormPhone != '' && app.contactFormPhone.length < 8) {
        finalError += '<li>Celular no tiene la longitud correcta (8 caracteres exactos)</li>';
      }

      $('[data-error_list]').append(finalError);
      var error_list_li = $('[data-error_list] li').length;
      $('.error_count').text(error_list_li);

      if ($('[data-error_list] li').length > 0 || $('.rut_message').hasClass('show_rut_error')) {
        event.preventDefault();
        if ($('[data-error_list] li').length > 0) {
          $('#errorExplanation').show().fadeIn(500);
        } else {
          $('#errorExplanation').hide().fadeOut(500);
        }
      } else {
        $('#errorExplanation').hide().fadeOut(500);
      }
    },
    _contactCaptcha: function _contactCaptcha() {
      var actCallback = function actCallback() {
        if ($('#contactFormSubmit').length) {
          $('#contactFormSubmit').prop('disabled', false);
        }
        if ($('#orderTrackingNumber').length) {
          $('#orderTrackingNumber').prop('disabled', false);
        }
        $('#re-captcha').remove();
        $('#re_captcha_dummy').removeClass('d-none');
      };
      var expCallback = function expCallback() {
        if ($('#contactFormSubmit').length) {
          $('#contactFormSubmit').prop('disabled', true);
        }
        if ($('#orderTrackingNumber').length) {
          $('#orderTrackingNumber').prop('disabled', true);
        }
      };
      var widget = window.grecaptcha.render(document.getElementById('re-captcha'), {
        sitekey: '6LdBKc0UAAAAAHFqmQIomLuXHJ5fr6ZLeqvv1GHH', // Sitekey, Retrieving from reCaptcha
        theme: 'light',
        callback: actCallback,
        'expired-callback': expCallback
      });
    },
    _contactCaptcha2: function _contactCaptcha2() {
      var actCallback = function actCallback() {
        if ($('#ticketTrackingNumber').length) {
          $('#ticketTrackingNumber').prop('disabled', false);
        }
        if (grecaptcha.getResponse(widget2) && grecaptcha.getResponse(widget2) != '' && grecaptcha.getResponse(widget2) != undefined && grecaptcha.getResponse(widget2) != null) {
          app.grecapchaTrackingNumber = grecaptcha.getResponse(widget2);
        }

        $('#re-captcha2').remove();
        $('#re_captcha_dummy2').removeClass('d-none');
      };
      var expCallback = function expCallback() {
        if ($('#ticketTrackingNumber').length) {
          $('#ticketTrackingNumber').prop('disabled', true);
        }
      };
      var widget2 = window.grecaptcha.render(document.getElementById('re-captcha2'), {
        sitekey: '6LdBKc0UAAAAAHFqmQIomLuXHJ5fr6ZLeqvv1GHH', // Sitekey, Retrieving from reCaptcha
        theme: 'light',
        callback: actCallback,
        'expired-callback': expCallback
      });
    },
    _countDownLangChange: function _countDownLangChange() {
      var x = setInterval(function () {
        $('.vuejs-countdown li').each(function () {
          var val = $(this).find('.text').text();
          if (val != undefined && (val == 'days' || val == 'day')) {
            $(this).find('.text').html(val.replace(val, 'dias'));
          } else if (val != undefined && (val == 'hours' || val == 'hour')) {
            $(this).find('.text').html(val.replace(val, 'horas'));
          } else if (val != undefined && val == 'min') {
            $(this).find('.text').html(val.replace(val, 'min'));
          } else if (val != undefined && val == 'Sec') {
            $(this).find('.text').html(val.replace(val, 'segs'));
          }
        });
      }, 2000);
    },
    _trackTicket: function _trackTicket() {
      var ticketNumber = app.ticketTrackingNumber;
      var data = {
        Boleta: ticketNumber
      };
      $.ajax({
        type: 'POST',
        url: 'https://app.kitchencenter.cl/api/track-order',
        dataType: 'json',
        data: data,
        success: function success(data) {
          app.OrderTrackingDetails = data;
          if (app.currentTemplate == 'orderTracking') {
            app.isLoading = false;
            localStorage.setItem('ticketTrackingNumber', ticketNumber);
            localStorage.setItem('orderTrackingNumber', '');
            window.location.href = '/pages/tracking-results-orden';
          }
        },
        error: function error(res) {
          console.log(res);
        }
      });
    },
    _trackOrder: function _trackOrder() {
      if (app.currentTemplate == 'orderTracking') {
        app.isLoading = true;
      }
      var orderNumber = app.orderTrackingNumber;
      var data = {
        Pedido: orderNumber
      };
      $.ajax({
        type: 'POST',
        url: 'https://app.kitchencenter.cl/api/track-order',
        dataType: 'json',
        data: data,
        success: function success(data) {
          app.OrderTrackingDetails = data;
          if (app.currentTemplate == 'orderTracking') {
            app.isLoading = false;
            localStorage.setItem('ticketTrackingNumber', '');
            localStorage.setItem('orderTrackingNumber', orderNumber);
            window.location.href = '/pages/tracking-results-orden';
          }
        },
        error: function error(res) {
          console.log(res);
        }
      });
    },
    _startEndDateTimer: function _startEndDateTimer() {
      var start_date = $('[data-start-date]').attr('data-start-date');
      var newStartDate = new Date(start_date);
      var countDownStartDate = new Date(newStartDate).getTime();

      var end_date = $('[data-end-date]').attr('data-end-date');
      var newEndDate = new Date(end_date);
      var countDownEndDate = new Date(newEndDate).getTime();

      var x = setInterval(function () {
        var now = new Date().getTime();
        var startDateRemaining = countDownStartDate - now;
        var endDateRemaining = countDownEndDate - now;
        if (startDateRemaining < 0) {
          // clearInterval(x);
          $('[data-end-date]').addClass('d-block').removeClass('d-none');
          $('[data-start-date]').addClass('d-none').removeClass('d-block');
          app.isNotAvailable = false;
        }
        if (endDateRemaining < 0) {
          // clearInterval(x);
          $('[data-end-date]').addClass('d-none').removeClass('d-block');
          $('.index-timer-banner').addClass('d-none');
        }
      }, 1000);
    },
    _changeKCBox: function _changeKCBox() {
      $('[data-boxnumber]').each(function (index, box) {
        var _this2 = this;

        if ($(this).hasClass('d-block')) {
          var current_box = parseInt($(this).attr('data-boxnumber').split('kcbox')[1]);
          var next_box = current_box + 1;

          var start_date_ = $(this).find('[data-box-start-date]').attr('data-box-start-date');
          var newStartDate_ = new Date(start_date_);
          var countDownStartDate_ = new Date(newStartDate_).getTime();

          var end_date_ = $(this).find('[data-box-end-date]').attr('data-box-end-date');
          var newEndDate_ = new Date(end_date_);
          var countDownEndDate_ = new Date(newEndDate_).getTime();

          var y = setInterval(function () {
            var now_ = new Date().getTime();
            var startDateRemaining_ = countDownStartDate_ - now_;
            var endDateRemaining_ = countDownEndDate_ - now_;

            if (startDateRemaining_ < 0) {
              // $(this).find('[data-box-end-date]').addClass('d-block').removeClass('d-none');
              // $(this).find('[data-box-start-date]').addClass('d-none').removeClass('d-block');
              $(_this2).find('[data-else]').addClass('d-block').removeClass('d-none');
              $(_this2).find('[data-if]').addClass('d-none').removeClass('d-block');
              app.isBoxAvailable = true;
            }

            if (endDateRemaining_ < 0) {
              $(_this2).siblings('[data-boxnumber=kcbox' + next_box + ']').addClass('d-block').removeClass('d-none');
              $(_this2).addClass('d-none').removeClass('d-block');
              setTimeout(function () {
                if ($('[data-boxnumber=kcbox' + next_box + ']').length <= 0) {
                  $('[data-event-text]').addClass('d-block').removeClass('d-none');
                }
              }, 1500);
            }
          }, 1000);
        }
      });
      // if($('[data-boxnumber="kcbox1"]').hasClass('d-block')){	
      //   $('[data-kc-boxes]').addClass('d-none');	
      // }
    },
    _kboxShipping: function _kboxShipping(event) {
      if (app.selectedRegion != null) {
        var valReg = app.selectedRegion;
      }
      if (app.selectedComuna != null) {
        var valCom = app.selectedComuna;
      }

      var itsPreorder = null;
      var marketplaceSaller = null;
      var $this = $(event.currentTarget);
      var $thishtml = $(event.currentTarget).html();

      var kboxproductData = JSON.parse($this.parents('[data-boxnumber]').find('[data-else] [data-kboxproduct-json]').html());
      var kboxPrd = kboxproductData.product;

      kboxPrd.tags.forEach(function (tag) {
        if (tag.match('preventa_')) {
          var dateCheck = tag.split('preventa_');
          var today = new Date();
          var preorderDate = new Date(dateCheck[1]);
          if (preorderDate > today) {
            itsPreorder = tag;
          }
        }
        if (tag.match('seller_')) {
          marketplaceSaller = tag.split('seller_');
          marketplaceSaller = marketplaceSaller[1];
        }
      });

      var kboxprod_variant = $this.parents('[data-boxnumber]').find('.kboxprod-variant').attr('data-variant-inventory-qty');
      $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[weight]" value="' + parseInt(kboxPrd.variants[0].weight) / 1000 + '" />');
      $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[inventory]" value="' + kboxprod_variant + '" />');
      $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[sku]" value="' + kboxPrd.variants[0].sku + '" />');
      $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[tags]" value="' + kboxPrd.tags.toString() + '" />');
      if (itsPreorder != null) {
        $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_type]" class="shipp_type" value="preorder" />');
      } else if (marketplaceSaller != null) {
        $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_type]" class="shipp_type" value="marketplace" />');
      } else {
        $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_type]" class="shipp_type" value="delivery" />');
      }

      var tempArray = [];

      kboxPrd.properties = { 'tags': kboxPrd.tags.toString(), 'sku': kboxPrd.variants[0].sku, 'inventory': kboxPrd.variants[0].inventory, 'weight': parseInt(kboxPrd.variants[0].weight) / 1000 };
      kboxPrd.variant_id = kboxPrd.variants[0].id;
      kboxPrd.product_type = kboxPrd.type;
      tempArray.push(kboxPrd);

      $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
        var data = {
          location_id: 'null',
          shipping_type: 'delivery',
          region: valReg,
          district: valCom,
          cart: JSON.stringify({ items: tempArray }),
          date_count: 1,
          change_shipping_type: 0
        };

        if (app.freeShippingEnabled) {
          var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
        } else {
          var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
        }

        $.ajax({
          type: 'POST',
          url: ajax_url,
          dataType: 'json',
          data: data,
          success: function success(data) {
            data.forEach(function (item, index) {
              if (item.type == 'preorder') {
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[delivery_date]" class="shipp_date_prop" value="' + item.start_date + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[range_date]" class="shipp_rangedate_prop" value="' + item.start_date + ' - ' + item.end_date + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[fulfillment_date]" class="shipp_fulldate_prop" value="' + item.fulfillment_date + '" />');
              } else if (item.type == 'marketplace') {
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[delivery_date]" class="shipp_date_prop" value="' + item.delivery_date + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[range_date]" class="shipp_rangedate_prop" value="' + item.start_date + ' - ' + item.end_date + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[fulfillment_date]" class="shipp_fulldate_prop" value="' + item.fulfillment_date + '" />');
              } else {
                if (item.shipping_type == 'pickup') {
                  var ship_pick_dates = item.pickup_dates;
                } else {
                  var ship_pick_dates = item.shipping_dates;
                }

                var dileveryDate = [];
                var getMonth = '';
                var firstDate = '';
                var firstFullfillDate = '';

                var count = 0;
                $.each(ship_pick_dates, function (shipping_date) {
                  if (count == 0) {
                    getMonth = shipping_date;
                    firstDate = shipping_date;
                    firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                  }
                  if (count < 10) {
                    dileveryDate.push(shipping_date);
                  }
                  count = count + 1;
                });
                getMonth = getMonth.split('-')[1];

                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[pick_available]" class="pick_available" value="' + item.pick_available + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[delivery_date]" class="shipp_date_prop" value="' + firstDate + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[fulfillment_date]" class="shipp_fulldate_prop" value="' + firstFullfillDate + '" />');
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[pickup_date]" class="pick_date" value="" />');
              }
              $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_price]" class="shipp_price_prop" value="' + item.shipping_price + '" />');

              if (item.same_day_delivery_option == true) {
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[same_day_delivery_option]" class="same_day_del" value="' + item.same_day_delivery_option + '" />');
              } else {
                $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[same_day_delivery_option]" class="same_day_del" value="" />');
              }

              $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_storeid]" class="shipp_storeid" value="" />');
              $this.parents('[data-boxnumber]').find('.add_prop_div').append('<input type="hidden" name="properties[shipping_store]" class="shipp_store" value="" />');
            });

            setTimeout(function () {
              $this.siblings('[data-add-to-cart-box]').trigger('click');
              $this.html($thishtml);
            }, 2000);
          }
        });
      } else {
        setTimeout(function () {
          $this.siblings('[data-add-to-cart-box]').trigger('click');
          $this.html($thishtml);
        }, 2000);
      }
    },
    _downloadFiles: function _downloadFiles(link, name) {
      var oReq = new XMLHttpRequest();
      oReq.open('GET', link, true);
      oReq.responseType = 'blob';
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: 'application/pdf'
        });
        saveAs(file, name);
      };
      oReq.send();
    },
    _openDistrict: function _openDistrict(event) {
      var $this = $(event.currentTarget);

      if ($this.hasClass('install-prod') == true || $this.hasClass('grill-prod') == true) {
        $('#modalForShipping').removeClass('showtoggle');
        $('#modalForShipping').addClass('installregion_toggle');
      } else if ($this.hasClass('dropdown-toggle')) {
        $('#modalForShipping').removeClass('installregion_toggle');
        $('#modalForShipping').addClass('showtoggle');
      }

      if ($this.attr('data-shiptype') == 'pickup') {
        $('[data-shipping-check]').attr('data-shipping_type', 'pickup');
      } else if ($this.attr('data-preorder') != null) {
        $('[data-shipping-check]').attr('data-shipping_type', 'preorder');
      } else if ($this.attr('data-marketplace') == null) {
        $('[data-shipping-check]').attr('data-shipping_type', 'delivery');
      } else if ($this.attr('data-marketplace') != null) {
        $('[data-shipping-check]').attr('data-shipping_type', 'marketplace');
      }

      // if($this.attr('data-preorder') != null){
      //   $('[data-shipping-check]').trigger('click');
      // }
      // else{

      $('#modalForShipping').removeClass('store-selection').css('top', '');
      $('#modalForShipping #exampleModalLongTitle').text('Selecciona tu comuna');
      $('#modalForShipping #exampleModalLongTitle').show();
      $('#modalForShipping').modal('show');
      // $('[data-stores]').addClass('d-none');
      $('.pick_pop').addClass('d-none');
      $('[data-shipping-check]').addClass('button-hidden');
      var regionsJson = void 0;

      var regionsLocalStrg = localStorage.getItem('regionsJsonLS');
      if (regionsLocalStrg && regionsLocalStrg != '' && regionsLocalStrg != undefined) {
        var regions = JSON.parse(regionsLocalStrg);
        regionsJson = regions;
        var homeRegion = '<option disabled selected value="">Selecciona Región</option>';
        var count = 0;
        var checkReg = '';
        $.each(regions, function () {
          $.each(this, function (k, value) {
            if (value.region != 'Regi') {
              if (value.region != 'Portugal') {
                if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                  checkReg = ' selected="selected"';
                } else {
                  checkReg = '';
                }
                if (count == 0) {
                  homeRegion += '<option value="' + value.region + '"' + checkReg + '>' + value.region + '</option>';
                } else {
                  if (homeRegion.indexOf(value.region) == -1) {
                    homeRegion += '<option value="' + value.region + '"' + checkReg + '>' + value.region + '</option>';
                  }
                }
              }
            }
            count++;
          });
        });
        $('[data-regions]').html(homeRegion).show();
        setTimeout(function () {
          $('[data-regions]').trigger('change');
        }, 400);
        $('#modalForShipping').modal('show');
      } else {
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/calendar/regions',
          success: function success(regions) {
            regionsJson = regions;
            var homeRegion = '<option disabled selected value="">Selecciona Región</option>';
            var count = 0;
            var checkReg = '';
            $.each(regions, function () {
              $.each(this, function (k, value) {
                if (value.region != 'Regi') {
                  if (value.region != 'Portugal') {
                    if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                      checkReg = ' selected="selected"';
                    } else {
                      checkReg = '';
                    }
                    if (count == 0) {
                      homeRegion += '<option value="' + value.region + '"' + checkReg + '>' + value.region + '</option>';
                    } else {
                      if (homeRegion.indexOf(value.region) == -1) {
                        homeRegion += '<option value="' + value.region + '"' + checkReg + '>' + value.region + '</option>';
                      }
                    }
                  }
                }
                count++;
              });
            });
            $('[data-regions]').html(homeRegion).show();
            $('[data-regions]').trigger('change');
            $('#modalForShipping').modal('show');
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }

      if (app.selectedComuna != null && app.selectedComuna != '') {
        $('.changeDate-modal').addClass('showtoggle');
        $('.changeDate-modal .modal-dialog').addClass('m-0').removeClass('modal-dialog-centered');
      }

      $('[data-regions]').change(function () {
        var val = $(this).val();
        if (val != '' && val != null) {
          var homeDistrict = '';
          var checkCom = '';
          $.each(regionsJson[val], function (k, value) {
            var disttorg = value.district;
            var distt = value.district;
            // distt = distt.replaceAll('í','i').replaceAll('á','a');
            distt = distt.replace(/í/g, 'i');
            distt = distt.replace(/á/g, 'a');
            if (app.selectedComuna != null && app.selectedComuna != '' && (app.selectedComuna == distt || app.selectedComuna == disttorg)) {
              checkCom = ' selected="selected"';
            } else {
              checkCom = '';
            }
            homeDistrict += '<option value="' + disttorg + '" data-value="' + distt + '" data-out="' + value.is_out_of_delivery + '"' + checkCom + '>' + distt + '</option>';
          });
          $('[data-district]').html(homeDistrict).show();
          $('[data-district]').trigger('change');

          if ($this.attr('data-shiptype') == 'pickup') {
            $('[data-shipping-check]').addClass('d-none');
            $('[data-store-check]').removeClass('d-none');
            $('[data-store-check]').removeClass('button-hidden');
          } else {
            $('.pick_pop').addClass('d-none');

            $('[data-shipping-check]').removeClass('d-none');
            $('[data-store-check]').addClass('d-none');

            if ($('[data-district]').val() != '' && $('[data-regions]').val() != '' && $('[data-district]').val() != null && $('[data-regions]').val() != null) {
              $('[data-shipping-check]').removeClass('button-hidden');
            }
          }
        }
        if ($('.installregion_toggle').length > 0) {
          if (val !== 'Región Metropolitana') {
            $('[data-msg-change]').html('<span class="font-weight-bold d-flex align-items-center" style="font-size: 14px;opacity: 1;color: #ccc;">Servicio de instalación via soporte <div class="tooltip-hover ml-1"><img src="https://cdn.shopify.com/s/files/1/0111/6448/3647/files/tooltip_36aa766a-e99b-4a0e-a010-4e2bd3354456.png?v=1638206315&quot; alt="icon" class="image-wrapper w-20"><div class="top bg-white text-black position-absolute text-wrap tooltip-text" style=""><p>Para instalaciones fuera de la Región Metropolitana, por favor contrata el servicio a través de soporte después de realizar tu compra.</p></div></div></span>');
            // $('.installregion_toggle [data-shipping-check]').addClass('disabled').prop('disabled', true);
          } else {
            $('[data-msg-change]').html('Agregar servicios de instalación');
            // $('.installregion_toggle [data-shipping-check]').removeClass('disabled').prop('disabled', false);
          }
          $('.installregion_toggle [data-shipping-check]').removeClass('disabled').prop('disabled', false);
        }
      });

      $('[data-stores]').change(function () {
        if ($(this).val() != '') {

          var array = [];
          app.product.properties = { 'tags': app.product.tags.toString(), 'sku': app.currentVariant.sku, 'inventory': app.currentVariant.inventory, 'weight': parseInt(app.currentVariant.weight) / 1000 };
          app.product.variant_id = app.currentVariant.id;
          app.product.product_type = app.product.type;
          array.push(app.product);
          var contains = { items: array };

          var data = {
            region: app.selectedRegion,
            district: app.selectedComuna,
            cart: JSON.stringify(contains),
            location_id: $(this).val()
          };
          $.ajax({
            type: 'POST',
            url: 'https://app.kitchencenter.cl/api/calendar/store-inventory',
            dataType: 'json',
            data: data,
            success: function success(store_inventory) {}
          });

          $('[data-shipping-check]').removeClass('button-hidden');
        } else {
          $('[data-shipping-check]').addClass('button-hidden');
        }
      });
      // }

      if ($('.showtoggle').length > 0) {
        if ($('.showtoggle select').val() !== 'Región Metropolitana') {
          $('.installation-service label, .grill-service label').addClass('disable').css('cursor', 'default');
          $('.installation-service label a, .grill-service label a').removeClass('text-decoration-underline');
        } else {
          $('.installation-service label, .grill-service label').removeClass('disable').css('cursor', 'pointer');
          $('.installation-service label a, .grill-service label a').addClass('text-decoration-underline');
        }
        $('.showtoggle [data-shipping-check]').removeClass('disabled').prop('disabled', false);
      }
    },
    _checkStore: function _checkStore(event) {
      var $this = $(event.currentTarget);

      if (app.currentTemplate == 'product') {
        $('#app').addClass('showtoggle');
      }

      if (window.innerWidth < 768) {
        $('#modalForShipping').addClass('store-selection').css('top', '30px');
      } else {
        $('#modalForShipping').addClass('store-selection').css('top', '-85px');
      }
      $('[data-regions], [data-district]').hide();
      $('#modalForShipping #exampleModalLongTitle').text('Selecciona tu tiendas');
      $('#modalForShipping #exampleModalLongTitle').hide();

      if (app.selectedRegion != null) {
        var valReg = app.selectedRegion;
      } else {
        var valReg = $this.parents('#modalForShipping').find('[data-regions]').val();
      }

      if (app.selectedComuna != null) {
        var valCom = app.selectedComuna;
      } else {
        var valCom = $this.parents('#modalForShipping').find('[data-district]').val();
      }

      // var valReg = $this.parents('#modalForShipping').find('[data-regions]').val();
      // var valCom = $this.parents('#modalForShipping').find('[data-district]').val();

      var invArray = [{
        "id": app.currentVariant.id,
        "properties": {
          "inventory": app.currentVariant.inventory,
          "SKU": app.currentVariant.sku,
          "tags": app.product.tags.toString(),
          "weight": parseInt(app.currentVariant.weight) / 1000,
          "vendor": app.product.vendor,
          "shipping_type": "pickup"
        },
        "quantity": 1,
        "variant_id": app.currentVariant.id,
        "vendor": app.product.vendor,
        "requires_shipping": true,
        "product_type": app.product.product_type
      }];

      var contains = { items: invArray };

      var storesJson = void 0;
      var storeCount = 0;
      var data = {
        region: valReg,
        district: valCom,
        cart: JSON.stringify(contains)
      };
      $.ajax({
        type: 'POST',
        url: 'https://app.kitchencenter.cl/api/calendar/pickup-store',
        dataType: 'json',
        data: data,
        success: function success(storesdata) {
          if (storesdata.pickup[0].stores.length > 0) {
            storesJson = storesdata.pickup[0].stores;
            var pickStore = '<option disabled selected value="">Selecciona tienda</option>';
            var storeList = '';
            $.each(storesJson, function (k, value) {
              if (value.inventory > 0) {
                pickStore += '<option value="' + value.location_id + '" data-store="' + value.name + '"  data-inventory="' + value.inventory + '">' + value.name + '</option>';
                storeList += '<p class="d-flex align-items-center mb-2" data-inventory="' + value.inventory + '">';
                storeList += '<svg height="682pt" viewBox="-119 -21 682 682.66669" width="682pt" xmlns="http://www.w3.org/2000/svg">';
                storeList += '<path d="m216.210938 0c-122.664063 0-222.460938 99.796875-222.460938 222.460938 0 154.175781 222.679688 417.539062 222.679688 417.539062s222.242187-270.945312 222.242187-417.539062c0-122.664063-99.792969-222.460938-222.460937-222.460938zm67.121093 287.597656c-18.507812 18.503906-42.8125 27.757813-67.121093 27.757813-24.304688 0-48.617188-9.253907-67.117188-27.757813-37.011719-37.007812-37.011719-97.226562 0-134.238281 17.921875-17.929687 41.761719-27.804687 67.117188-27.804687 25.355468 0 49.191406 9.878906 67.121093 27.804687 37.011719 37.011719 37.011719 97.230469 0 134.238281zm0 0"></path>';
                storeList += '</svg>';
                storeList += '<span class="text-initial">' + value.name + '</span>';
                storeList += '</p>';

                storeCount = storeCount + 1;
              }
            });
            if (storeCount > 1) {
              var popPos = parseInt($('#modalForShipping.store-selection').css('top')) - (storeCount - 1) * 30;
              $('#modalForShipping.store-selection').css('top', popPos + 'px');
            }
            if (storeCount > 0) {
              $('[data-stores]').html(pickStore);
              // $('[data-stores]').removeClass('d-none');
              $('.pick_pop .list').html(storeList);
              $('.pick_pop').removeClass('d-none');

              $('[data-shipping-check]').addClass('button-hidden');
              // $('[data-shipping-check]').removeClass('d-none');
              $('[data-shipping-check]').addClass('d-none');
              $('[data-store-check]').addClass('d-none');

              $('#modalForShipping').modal('show');
            } else {
              $('.no-stores').remove();
              $this.after('<p class="text-danger no-stores my-2 small">No hay tiendas disponibles</p>');
              // $('.no-stores').delay(5000).fadeOut('slow');
            }
          } else {
            $('.no-stores').remove();
            $this.after('<p class="text-danger no-stores my-2 small">No hay tiendas disponibles</p>');
          }
          return false;
        }
      });
    },
    _openModelNew: function _openModelNew(event) {
      $("#modalForShippingHomeCol").modal("show");
      if (app.selectedComuna && app.selectedComuna != '' && app.currentTemplate == 'cart') {
        $('#app').removeClass('showpopup').addClass('showtoggle');
      } else {
        $('#app').removeClass('showtoggle').addClass('showpopup');
      }
      $('[data-shipping-check]').attr('data-change_comuna', true);
      $('[data-shipping-check]').attr('data-shipp_type', 'delivery');
      $('[data-shipping-check]').attr('data-change_shipping_type', '0');
      var regionsJson = void 0;
      var regionsLocalStrg = localStorage.getItem('regionsJsonLS');
      if (regionsLocalStrg && regionsLocalStrg != null) {
        var regions = JSON.parse(regionsLocalStrg);
        regionsJson = regions;
        var homeRegion = '<option disabled selected value="">Selecciona tu Región</option>';
        var count = 0;
        var checkReg = '';
        $.each(regions, function () {
          $.each(this, function (k, value) {
            if (value.region != 'Regi') {
              if (value.region != 'Portugal') {
                if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                  checkReg = ' selected="selected"';
                } else {
                  checkReg = '';
                }
                if (count == 0) {
                  homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                } else {
                  if (homeRegion.indexOf(value.region) == -1) {
                    homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                  }
                }
              }
            }
            count++;
          });
        });
        $('[data-regions]').html(homeRegion);
        var checkCom = '';
        var homeDistrict = '<option value="" disabled selected>Selecciona tu Comuna</option>';
        $.each(regionsJson[$('[data-regions]').val()], function (k, value) {
          var disttorg = value.district;
          var distt = value.district;
          distt = distt.replace(/í/g, 'i');
          distt = distt.replace(/á/g, 'a');
          if (app.selectedComuna != null && app.selectedComuna != '' && (app.selectedComuna == distt || app.selectedComuna == disttorg)) {
            checkCom = ' selected="selected"';
          } else {
            checkCom = '';
          }
          homeDistrict += '<option value="' + disttorg + '" data-value="' + distt + '" data-out="' + value.is_out_of_delivery + '"' + checkCom + '>' + distt + '</option>';
        });
        $('[data-district]').html(homeDistrict);
      }
      $('#modalForShippingHomeCol [data-regions]').change(function () {
        var val = $(this).val();
        var homeDistrict = '<option value="" disabled selected>Selecciona tu Comuna</option>';
        var checkCom = '';
        $.each(regionsJson[val], function (k, value) {
          var disttorg = value.district;
          var distt = value.district;
          distt = distt.replace(/í/g, 'i');
          distt = distt.replace(/á/g, 'a');
          if (app.selectedComuna != null && app.selectedComuna != '' && (app.selectedComuna == distt || app.selectedComuna == disttorg)) {
            checkCom = ' selected="selected"';
          } else {
            checkCom = '';
          }
          homeDistrict += '<option value="' + disttorg + '" data-value="' + distt + '" data-out="' + value.is_out_of_delivery + '"' + checkCom + '>' + distt + '</option>';
        });
        $('[data-district]').html(homeDistrict);
      });
      $('#modalForShippingHomeCol [data-district]').change(function () {
        if ($(this).val() != '' && $(this).val() != null) {
          $('[data-store-all]').removeClass('button-hidden');
        } else {
          $('[data-store-all]').addClass('button-hidden');
        }
      });
    },
    _storeRegionComuna: function _storeRegionComuna(event) {
      $('[data-store-all]').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      if (app._getCookie('selCommonC') && app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {} else {
        $(".template-cart").prepend('<div class="mp-loader"><div class="mp-spinner"></div></div>');
      }

      var t = $("#modalForShippingHomeCol [data-regions]").val();
      var a = $("#modalForShippingHomeCol [data-district]").val();
      $('.show-autocon [data-regions]').val(t).trigger('change');
      $('.show-autocon [data-district]').val(a).trigger('change');
      document.cookie = "selectedRegion=" + t + ";path=/;", document.cookie = "selCommonR=" + t + ";path=/;";
      document.cookie = "selectedComuna=" + a + ";path=/;";
      document.cookie = "selCommonC=" + a + ";path=/;";
      app.selectedRegion = t;
      app.selectedComuna = a;

      $.post('/cart.js', {
        attributes: {
          'Region': t,
          'Comuna': a
        }
      }).done(function () {
        $('[data-shipping-check]').trigger('click');
      });
    },
    _checkShipping: function _checkShipping(event) {
      var $this = $(event.currentTarget);
      var array = [];
      var tempObj = {};
      var tempArray = [];

      if (app.currentTemplate === 'product') {
        app.product.properties = { 'tags': app.product.tags.toString(), 'sku': app.currentVariant.sku, 'inventory': app.currentVariant.inventory, 'weight': parseInt(app.currentVariant.weight) / 1000 };
        app.product.variant_id = app.currentVariant.id;
        app.product.product_type = app.product.type;
        array.push(app.product);
        app.product.quantity = 1;
      } else {
        app.quickShop.product.properties = { 'tags': app.quickShop.product.tags.toString(), 'sku': app.quickShop.sku, 'inventory': app.quickShop.inventory, 'weight': app.quickShop.weight / 1000 };
        array.push(app.quickShop.product);
        app.quickShop.product.quantity = 1;
      }

      if ($('[data-regions]').val() != null && $('[data-regions]').val() != 'null' && $('[data-regions]').val() != '') {
        //   document.cookie = `selectedRegion=`+$('[data-regions]').val();+`path=/`;
        app.selectedRegion = $('[data-regions]').val();
      }
      if ($('[data-district]').val() != null && $('[data-district]').val() != 'null' && $('[data-district]').val() != '') {
        //   document.cookie = `selectedComuna=`+$('[data-district]').val();+`path=/`;
        app.selectedComuna = $('[data-district]').val();
      }
      //app.selectedComuna = $('[data-district]').val();

      var contains = { items: tempArray };

      var shipping_type = $('[data-shipping-check]').attr('data-shipping_type');

      if (shipping_type == 'pickup') {
        var location_id = $('[data-stores]').val();
      } else {
        var location_id = 'null';
      }

      if (app.selectedRegion != null) {
        var valReg = app.selectedRegion;
      } else {
        var valReg = $('[data-regions]').val();
      }

      if (app.selectedComuna != null) {
        var valCom = app.selectedComuna;
      } else {
        var valCom = $('[data-district]').val();
      }

      // document.cookie = 'selCommonC='+valCom+';path=/'+';';

      if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
        var data = {
          location_id: location_id,
          shipping_type: shipping_type,
          region: valReg,
          district: valCom,
          cart: JSON.stringify({ items: [app.product] }),
          date_count: 10,
          change_shipping_type: 0
        };

        if (app.freeShippingEnabled) {
          var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
        } else {
          var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
        }

        $.ajax({
          type: 'POST',
          url: ajax_url,
          dataType: 'json',
          data: data,
          beforeSend: function beforeSend() {
            $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
          },
          success: function success(data) {
            $this.html('Seleccionar');
            $('#modalForShipping').modal('hide');
            $('[data-shipping-check]').addClass('button-hidden');
            if ($('.installation-service').length > 0 || $('.grill-service').length > 0) {
              if ($("#modalForShipping [data-regions] option:selected").text() !== 'Región Metropolitana') {
                $('[data-shipping-check]').addClass('button-hidden');
                $('.installation-service label, .grill-service label').addClass('disable');
                $('.installation-service input, .grill-service input').prop("checked", false);
              } else {
                $('[data-shipping-check]').removeClass('button-hidden');
                $('.installation-service label, .grill-service label').removeClass('disable');
              }
            }
            // $('[data-pickup]').removeClass('d-none');
            // $('[data-district-select]').text($('[data-district]').val());
            if (item.pick_available) {
              app.isAvailableShip = true;
            }
            data.forEach(function (item, index) {
              if (index == 0) {
                if (item.type == 'preorder') {
                  // $('[data-preorderdel]').text(item.text).removeClass('d-none');
                  $('[data-preorderdel]').find('[data-msg-home-1]').text(item.shipping_price);
                  $('[data-preorderdel]').find('[data-msg-home-2]').text(app.selectedComuna);
                  $('[data-preorderdel]').removeClass('d-none');

                  if ($('input.shipp_date_prop').val() == '') {
                    $('input.shipp_date_prop').val(item.start_date);
                  } // item.end_date
                  if ($('input.shipp_rangedate_prop').val() == '') {
                    $('input.shipp_rangedate_prop').val(item.start_date + ' - ' + item.end_date);
                  }
                  if ($('input.shipp_fulldate_prop').val() == '') {
                    $('input.shipp_fulldate_prop').val(item.fulfillment_date);
                  } // item.start_date

                  // $('input.shipp_date_prop').val(item.start_date);
                  $('.div_left [data-selcomuna]').text(app.selectedComuna);
                } else if (item.type == 'marketplace') {
                  // $('[data-del_seller]').text(item.text).removeClass('d-none');
                  $('[data-del_seller]').find('[data-msg-home-1]').text(item.shipping_price);
                  $('[data-del_seller]').find('[data-msg-home-2]').text(app.selectedComuna);
                  $('[data-del_seller]').removeClass('d-none');

                  if ($('input.shipp_date_prop').val() == '') {
                    $('input.shipp_date_prop').val(item.delivery_date);
                  }
                  if ($('input.shipp_rangedate_prop').val() == '') {
                    $('input.shipp_rangedate_prop').val(item.start_date + ' - ' + item.end_date);
                  }
                  if ($('input.shipp_fulldate_prop').val() == '') {
                    $('input.shipp_fulldate_prop').val(item.fulfillment_date);
                  }

                  $('.div_left [data-selcomuna]').text(app.selectedComuna);
                } else {

                  if (shipping_type == 'pickup') {
                    var ship_pick_dates = item.pickup_dates;
                  } else {
                    var ship_pick_dates = item.shipping_dates;
                  }

                  var dileveryDate = [];
                  var getMonth = '';
                  var firstDate = '';
                  var firstFullfillDate = '';

                  var count = 0;
                  $.each(ship_pick_dates, function (shipping_date) {
                    if (count == 0) {
                      getMonth = shipping_date;
                      firstDate = shipping_date;
                      firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                    }
                    if (count < 10) {
                      dileveryDate.push(shipping_date);
                    }
                    count = count + 1;
                  });
                  getMonth = getMonth.split('-')[1];
                  // firstDate = firstDate.split('-')[2];

                  setTimeout(function () {
                    // if(app._getCookie('selectedComuna') != undefined && app._getCookie('selectedComuna') != '' && app._getCookie('selectedComuna') != 'selectedComuna') {
                    if (shipping_type == 'pickup') {
                      var locId = $('[data-stores]').val();
                      var storeName = $('[data-stores] option[value="' + locId + '"]').attr('data-store');
                      $('[data-pickup] [data-district-select]').text(storeName);
                      $('[data-pickup]').removeClass('d-none');
                      $('[data-homepick]').addClass('d-none');

                      $('[data-delavail]').removeClass('d-none');
                      $('[data-pickavail]').addClass('d-none');

                      $('input.shipp_store').val(storeName);
                      $('input.shipp_storeid').val(locId);

                      $('.sel_store').text(storeName);
                      $('.sel_store').removeClass('d-none');
                    } else {

                      $('[data-msg-home-1]').text(item.shipping_price);
                      $('[data-msg-home-2]').text(valCom);
                      $('[data-homepick]').removeClass('d-none');
                      $('[data-pickup]').addClass('d-none');

                      $('input.pick_available').val(item.pick_available);
                      // $('input.delivery_available').val('');

                      if (item.pick_available) {
                        $('[data-pickavail]').text('Disponible en ' + valCom);

                        $('.pick_div').addClass('class-enabled').removeClass('class-disabled');
                        $('.pick_div .check_store').removeClass('d-none');
                        $('.pick_div .green-checked-image').css('opacity', '1');
                      } else {
                        $('[data-pickavail]').text('La recogida no está disponible en ' + valCom);
                        // $('input.pick_available').val('');
                        // $('input.delivery_available').val('');

                        $('.pick_div').removeClass('class-enabled').addClass('class-disabled');
                        $('.pick_div .green-checked-image').css('opacity', '0');
                        $('.pick_div .check_store').addClass('d-none');
                      }
                      $('[data-pickavail]').removeClass('d-none');
                      $('[data-delavail]').addClass('d-none');

                      $('.sel_store').addClass('d-none');
                    }

                    $('[data-subhead]').addClass('d-none');
                    $('.div_left [data-selcomuna]').text(app.selectedComuna);

                    // var selShipdate = $(this).siblings('input[type="radio"]').val();
                    if ($('input.shipp_date_prop').val() == '') {
                      $('input.shipp_date_prop').val(firstDate);
                    }
                    if ($('input.shipp_fulldate_prop').val() == '') {
                      $('input.shipp_fulldate_prop').val(firstFullfillDate);
                    }

                    if ($('input.shipp_price_prop').val() == '') {
                      $('input.shipp_price_prop').val(item.shipping_price);
                    }
                    $('input.shipp_type').val(item.type);
                    if (item.same_day_delivery_option == true) {
                      $('input.same_day_del').val(item.same_day_delivery_option);
                    }
                    // }
                    // else{
                    //   $('#modalDate').modal('show');
                    // }

                    // if(app.selectedRegion != null && app.selectedComuna != null && (!$('#modalForShipping').is(':visible'))){
                    //   $('#modalDate').modal('show');
                    // }
                    // else{
                    //   $('#modalDate').modal('show');
                    // }


                    /*  code for store region / comuna once selected 1st time  */
                    if (valReg != null && valReg != '') {
                      document.cookie = 'selectedRegion=' + valReg + ';path=/' + ';';
                      app.selectedRegion = valReg;
                    }
                    if (valCom != null && valCom != '') {
                      document.cookie = 'selectedComuna=' + valCom + ';path=/' + ';';
                      app.selectedComuna = valCom;
                    }

                    if (item.allow_24H_delivery == true && app._getCookie('selCommonC') == app._getCookie('selectedComuna')) {
                      app.product.chck2del24h = 'yes';
                    } else {
                      app.product.chck2del24h = 'no';
                    }

                    return false;
                  }, 800);

                  return false;
                }
                if ($('input.shipp_price_prop').val() == '') {
                  $('input.shipp_price_prop').val(item.shipping_price);
                }
                $('input.shipp_type').val(item.type);
                if (item.same_day_delivery_option == true) {
                  $('input.same_day_del').val(item.same_day_delivery_option);
                }
              }
            });
          }
        });
      }
    },
    _scrollToContactForm: function _scrollToContactForm() {
      var $target = $('[data-contact-us]');
      $('html, body').animate({
        scrollTop: $target.offset().top - 30
      }, 'false');
    },
    _customQuickView: function _customQuickView() {
      $('body').on('click', '.quick-view-button', function (e) {
        e.preventDefault();
        var handle = $(this).data('quick-handle');
        var vId = $(this).closest('.card-product').find('.card-img a').attr('href');
        vId = vId.split('?variant=')[1];
        app._viewQuickShop(handle, '', $(this), vId);
      });
    },
    _customURL: function _customURL() {
      $('body').on('click', '#hawkitemlist a, [data-new-href]', function (event) {
        if ($(this).attr('href')) {
          var productUrl = $(this).attr('href');
          var trackingId = $(this).attr('data-trid');
          var dindex = $(this).attr('data-ind');
          var productId = $(this).attr('data-prid');

          productUrl = productUrl.split('products/')[1];
          var url = void 0;
          if (app.collection.handle == null) {
            url = "/collections/all/products/" + productUrl;
          } else {
            url = "/collections/" + app.collection.handle + "/products/" + productUrl;
          }
          $(this).attr('href', url);
          HawkSearch.link(event, trackingId, dindex, productId, 0);
        }
      });
    },
    _onPromoClick: function _onPromoClick(id, name, creative, position, url) {
      dataLayer.push({
        'event': 'promotionClick',
        'ecommerce': {
          'promoClick': {
            'promotions': [{
              'id': id, // Name or ID is required.
              'name': name,
              'creative': creative,
              'position': position
            }]
          }
        },
        'eventCallback': function eventCallback() {
          document.location = url;
        }
      });
      return true;
    },
    _submitKlavio: function _submitKlavio(event) {
      var email = $('#back-in-email').val();
      $.ajax({
        type: "POST",
        url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
        data: {
          a: "gNKg4J",
          email: email,
          variant: app.quickShop.currentVariant.id,
          product: app.quickShop.product.id, // Product must be present in Klaviyo catalog to record event.
          platform: "shopify",
          subscribe_for_newsletter: false // Optional with "g". Defaults to false if omitted.
        },
        // eslint-disable-next-line object-shorthand
        success: function success(response) {

          if (response != undefined && response.success == true) {
            app.backInStockDone = true;
            app.backInStockerror = false;
          } else {
            app.backInStockerror = true;
            app.backInStockDone = false;
          }
        }
      });
    },
    _triggerMainPopup: function _triggerMainPopup(event) {
      $('.notificationBanner a[data-selcomuna]')[0].click();
    },
    _editProfile: function _editProfile(event, customer_id) {
      var first_name = $('[data-edit-customer] [data-first]').val();
      var last_name = $('[data-edit-customer] [data-last]').val();
      var phone_number = $('[data-edit-customer] [data-customerPhoneNumber]').val();
      var rut_number = $('[data-edit-customer] [data-customerRut]').val();
      var $thisform = $(event.currentTarget).closest('form');

      $('[data-error_list]').empty();
      var finalError = '';

      if ($('[data-edit-customer] [data-first]').length && first_name == '') {
        finalError += '<li>Nombre no puede estar en blanco</li>';
        $('[data-edit-customer] [data-first]').addClass('border-danger');
        $('[data-edit-customer] [data-first]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-first]').attr('data-error-blank')).removeClass('d-none');
      } else if (!first_name.match(/^[A-Za-záéñóúüÁÉÑÓÚÜ\-' ]+$/)) {
        finalError += '<li>Nombre no puede estar en blanco</li>';
        $('[data-edit-customer] [data-first]').addClass('border-danger');
        $('[data-edit-customer] [data-first]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-first]').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('[data-edit-customer] [data-last]').length && last_name == '') {
        finalError += '<li>Apellidos no puede estar en blanco</li>';
        $('[data-edit-customer] [data-last]').addClass('border-danger');
        $('[data-edit-customer] [data-last]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-last]').attr('data-error-blank')).removeClass('d-none');
      } else if (!last_name.match(/^[A-Za-záéñóúüÁÉÑÓÚÜ\-' ]+$/)) {
        finalError += '<li>Apellidos no puede estar en blanco</li>';
        $('[data-edit-customer] [data-last]').addClass('border-danger');
        $('[data-edit-customer] [data-last]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-last]').attr('data-error-validate')).removeClass('d-none');
      }

      if (phone_number == '') {
        finalError += '<li>Celular no puede estar en blanco</li>';
        $('[data-edit-customer] [data-customerPhoneNumber]').addClass('border-danger');
        $('[data-edit-customer] [data-customerPhoneNumber]').parents('.form-group').addClass('error-phone');
        $('[data-edit-customer] [data-customerPhoneNumber]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-customerPhoneNumber]').attr('data-error-blank')).removeClass('d-none');
      } else if (phone_number.length != 9) {
        finalError += '<li>Celular no tiene la longitud correcta (8 caracteres exactos)</li>';
        $('[data-edit-customer] [data-customerPhoneNumber]').addClass('border-danger');
        $('[data-edit-customer] [data-customerPhoneNumber]').parents('.form-group').addClass('error-phone');
        $('[data-edit-customer] [data-customerPhoneNumber]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-customerPhoneNumber]').attr('data-error-validate')).removeClass('d-none');
      }

      if ($('[data-edit-customer] [data-customerRut]').length && rut_number == '') {
        finalError += '<li class="rut_error">Rut no puede estar en blanco</li>';
        $('[data-edit-customer] [data-customerRut]').addClass('border-danger');
        $('[data-edit-customer] [data-customerRut]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-customerRut]').attr('data-error-blank')).removeClass('d-none');
      } else if ($('[data-edit-customer] [data-customerRut]').hasClass('rut-error')) {
        finalError += '<li class="rut_error">Rut no puede estar en blanco</li>';
        $('[data-edit-customer] [data-customerRut]').addClass('border-danger');
        $('[data-edit-customer] [data-customerRut]').siblings('[data-error-msg]').text($('[data-edit-customer] [data-customerRut]').attr('data-error-validate')).removeClass('d-none');
      }

      $('[data-error_list]').append(finalError);
      var error_list_li = $('[data-error_list] li').length;
      $('.error_count').text(error_list_li);

      if ($('[data-error_list] li').length > 0 || $('.rut_message').hasClass('show_rut_error')) {
        $('#errorExplanation').show().fadeIn(500);
        return false;
      } else {
        $('#errorExplanation').hide().fadeOut(500);
        app.isLoading = true;
        var customerData = {};
        customerData.first_name = first_name;
        customerData.last_name = last_name;
        customerData.phone = "+56" + phone_number;

        if ($('[data-edit-customer] [data-all-tag]').attr('data-edit-customer') != undefined) {
          customerData.tags = "rut_" + rut_number.replaceAll('.', '').replaceAll('-', '') + "," + $('[data-edit-customer] [data-all-tag]').attr('data-edit-customer');
        } else {
          customerData.tags = "rut_" + rut_number.replaceAll('.', '').replaceAll('-', '');
        }

        var config = JSON.stringify({
          url: "/customers/" + customer_id + ".json",
          method: 'PUT',
          data: {
            customer: customerData
          }
        });
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.addEventListener('load', function () {
          var response = JSON.parse(xhr.responseText);
          console.log(response);
          app.isLoading = false;
          if (response.customer && response.customer.email != '') {
            setTimeout(function () {
              app._snotifyMessageSuccess('Success', '¡Actualizado exitosamente!');
            }, 3000);
            window.location.reload();
          } else {
            if (response.errors && response.errors.email && response.errors.email[0] == 'has already been taken') {
              app._snotifyMessage('Error', 'El correo ya a sido recibido!');
            } else if (response.errors && response.errors.phone && response.errors.phone[0] == 'Phone has already been taken') {
              app._snotifyMessage('Error', 'El teléfono ya ha sido tomado!');
            } else if (response.errors && response.errors.phone && response.errors.phone[0] == 'Enter a valid phone number to use this delivery method') {
              app._snotifyMessage('Error', 'Introduce un número de teléfono válido!');
            } else {
              app._snotifyMessage('Error', 'Algo está mal!');
            }
          }
        });
        xhr.open('PUT', '/tools/ha-api/shopify/common');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(config);
      }
    },
    _searchCustomer: function _searchCustomer(event) {
      var $thisform = $(event.currentTarget).closest('form');
      var resetCustomerEmail = $thisform.find('#resetCustomerEmail').val();
      var config = JSON.stringify({
        url: "/customers/search.json?query=email:" + resetCustomerEmail,
        method: 'GET',
        data: {}
      });
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.addEventListener('load', function () {
        var response = JSON.parse(xhr.responseText);
        app.isLoading = false;
        if (response.customers.length == 0) {
          $('.alert-custom').find('li').text('No se encontró ninguna cuenta con esta dirección de correo electrónico.');
          $('.alert-custom').removeClass('d-none').addClass('d-flex');
        } else if (response.customers[0].state == 'invited') {
          $('.alert-custom').find('li').text('Te hemos enviado un correo, revisalo para completar el registro.');
          $('.alert-custom').removeClass('d-none').addClass('d-flex');
        } else {
          $('.alert-custom').addClass('d-none').removeClass('d-flex');
          $thisform.submit();
        }
      });
      xhr.open('PUT', '/tools/ha-api/shopify/common');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(config);
    },
    _searchByOrderNumber: function _searchByOrderNumber(event) {
      var $this = $(this);
      var closest = $(event.currentTarget).closest('[data-wrap]');
      if (closest.find('[data-order-number]').val() == '') {
        closest.find('[data-order-number]').next().text('Please enter order number').removeClass('d-none');
        // app._snotifyMessage('Error', 'Please enter order number');   
        return false;
      } else {
        closest.find('[data-order-number]').next().text('').addClass('d-none');
      }

      if (closest.find('[data-order-email]').val() == '') {
        closest.find('[data-order-email]').next().text('Please enter email').removeClass('d-none');
        // app._snotifyMessage('Error', 'Ingresa tu correo electrónico');
        return false;
      } else if (!app._validateEmail(closest.find('[data-order-email]').val())) {
        closest.find('[data-order-email]').next().text('Ingresa un correo electrónico válido (nombre@ejemplo.com)').removeClass('d-none');
        return false;
      } else {
        closest.find('[data-order-email]').next().text('').addClass('d-none');
      }

      $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      var order_num = closest.find('[data-order-number]').val().replace('#', '');
      var config = JSON.stringify({
        "url": '/orders.json?query=' + order_num + '&status=any',
        "method": "GET",
        "data": {}
      });
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.addEventListener("load", function () {
        var response = JSON.parse(xhr.responseText);
        if (response.orders.length > 0) {
          var get_ind = 0;
          response.orders.forEach(function (item, index) {
            if (item.id == closest.find('[data-order-number]').val() || item.name == closest.find('[data-order-number]').val()) {
              get_ind = index;
            }
          });
          if (response.orders[get_ind].customer.email == closest.find('[data-order-email]').val()) {
            var prd_imgs = [];
            var order_lineitems = response.orders[get_ind].line_items;
            order_lineitems.forEach(function (line_item, index) {

              //// for shipping status 
              var fulfill_lineitems = response.orders[get_ind].fulfillments;
              if (fulfill_lineitems != null && fulfill_lineitems.length > 0) {
                fulfill_lineitems.forEach(function (fulfill_item, ff_index) {
                  fulfill_item.line_items.forEach(function (fulfill_subitem, fl_index) {
                    if (fulfill_subitem.id == line_item.id) {
                      response.orders[get_ind].line_items[index].shipment_status = fulfill_item.shipment_status;
                    }
                  });
                });
              }
              //// end for shipping status 

              var pr_id = line_item.product_id;

              var API = '';
              var shopifyCommonAPI = axios.create({
                baseURL: '/tools/ha-api/shopify/common',
                headers: {
                  Accept: 'application/json'
                }
              });

              var config1 = {
                "url": '/products/' + pr_id + '.json',
                "method": 'GET',
                "data": []
              };
              try {
                shopifyCommonAPI.post(API, config1).then(function (prdresponse) {
                  if (prdresponse.data.product.image != null) {
                    prd_imgs.push(pr_id + 'img:' + prdresponse.data.product.image.src);
                  } else {
                    prd_imgs.push(pr_id + 'img:https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg');
                  }
                });
              } catch (error) {
                console.log('error');
              }

              var order_data = response.orders[get_ind];
              order_data.prd_imgs = prd_imgs;

              app.orderTrackingData = response.orders[get_ind];
            });
          } else {
            // app._snotifyMessage('Error', 'Order not found');
            closest.find('.alert-order').removeClass('d-none').addClass('d-flex');
          }
        } else {
          // app._snotifyMessage('Error', 'Order not found');
          closest.find('.alert-order').removeClass('d-none');
          closest.find('.alert-order').addClass('d-flex');
        }
      });
      xhr.open("POST", "/tools/ha-api/shopify/common");
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(config);
      $this.html('INGRESA');
    },
    _searchByInvoiceNumber: function _searchByInvoiceNumber(event) {
      var $this = $(this);
      var closest = $(event.currentTarget).closest('[data-wrap]');

      if (closest.find('[data-ticket-number]').val() == '') {
        closest.find('[data-ticket-number]').next().text('Please enter invoice number').removeClass('d-none');
        // app._snotifyMessage('Error', 'Please enter invoice number');   
        return false;
      } else {
        closest.find('[data-ticket-number]').next().text('').addClass('d-none');
      }

      if (closest.find('[data-ticket-email]').val() == '') {
        closest.find('[data-ticket-email]').next().text('Please enter email').removeClass('d-none');
        // app._snotifyMessage('Error', 'Ingresa tu correo electrónico');
        return false;
      } else if (!app._validateEmail(closest.find('[data-ticket-email]').val())) {
        closest.find('[data-ticket-email]').next().text('Ingresa un correo electrónico válido (nombre@ejemplo.com)').removeClass('d-none');
        return false;
      } else {
        closest.find('[data-ticket-email]').next().text('').addClass('d-none');
      }

      var recapchaNumber = app.grecapchaTrackingNumber;
      $('#re-captcha2').remove();

      $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      var data = {
        "order_id": closest.find('[data-ticket-number]').val(), //"Test-Store-1",
        "email": closest.find('[data-ticket-email]').val(), //"fperez@gmail.com",
        "g-recaptcha-response": recapchaNumber
      };
      $.ajax({
        type: 'POST',
        url: 'https://app.kitchencenter.cl/api/calendar/v2/tracking',
        dataType: 'json',
        data: data,
        beforeSend: function beforeSend() {
          $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        },
        success: function success(response) {
          var orderTrackingObj = {};
          if (response.error) {
            closest.find('.alert-invoice').removeClass('d-none').addClass('d-flex');
            return false;
          } else {
            orderTrackingObj.name = response[0].order_id;
            orderTrackingObj.created_at = response[0].order_created_at;

            orderTrackingObj.shipping_address = {};
            orderTrackingObj.shipping_address.address1 = response[0].destination.destination_address1;
            orderTrackingObj.shipping_address.address2 = response[0].destination.destination_address2;
            orderTrackingObj.shipping_address.city = response[0].destination.destination_county;
            orderTrackingObj.shipping_address.province = response[0].destination.destination_region;

            // orderTrackingObj.line_items = [];
            var subtotal_prc = 0;
            response[0].items.forEach(function (line_item, index) {
              subtotal_prc = subtotal_prc + line_item.item_price * line_item.item_quantity;

              response[0].items[index].title = line_item.item_name;
              response[0].items[index].sku = line_item.item_sku;
              response[0].items[index].quantity = line_item.item_quantity;
              response[0].items[index].price = line_item.item_price;

              var body = JSON.stringify({
                query: "{\n                  products(first:1, query:\"sku:" + line_item.item_sku + "\") {\n                    edges {\n                      node {\n                        id\n                        title\n                        vendor\n                        images(first: 1) {\n                          edges {\n                            node {\n                              altText\n                              src\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }"
              });

              // var prd_imgs = [];
              fetch('/admin/api/2021-04/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  "Access-Control-Origin": "*",
                  'X-Shopify-Access-Token': "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"
                },
                body: body
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                var resultProducts = data.data.products.edges;
                if (resultProducts.length > 0) {
                  resultProducts.forEach(function (item) {
                    var product = item.node;
                    response[0].items[index].title = product.title;
                    response[0].items[index].vendor = product.vendor;

                    if (product.images.edges.length > 0) {
                      if (product.images.edges[0].node.src != null) {
                        response[0].items[index].prd_img = product.images.edges[0].node.src;
                      } else {
                        response[0].items[index].prd_img = 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg';
                      }
                    } else {
                      response[0].items[index].prd_img = 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg';
                    }
                  });
                }
              });

              if (line_item.item_agreed_date.length > 1) {
                response[0].items[index].last_step_date = line_item.item_agreed_date[0].substring(0, 10) + ' - ' + line_item.item_agreed_date[1].substring(0, 10);
              } else {
                response[0].items[index].last_step_date = line_item.item_agreed_date[0].substring(0, 10);
              }

              response[0].deliveries[0].items.forEach(function (delvline_item, dindex) {
                if (delvline_item.item_sku == line_item.item_sku) {
                  response[0].items[index].shipment_status = response[0].deliveries[0].status.standard_status;
                }
              });
            });

            orderTrackingObj.subtotal_price = subtotal_prc;
            orderTrackingObj.total_price = response[0].document_price;
            orderTrackingObj.financial_status = response[0].payment_status;

            orderTrackingObj.line_items = response[0].items;

            // add data in orderTrackingData
            app.orderTrackingData = orderTrackingObj;
          }
        },

        error: function error(jqXhr, json, errorThrown) {
          // this are default for ajax errors 
          var errors = jqXhr.responseJSON;
        }
      });
    },
    _clickFacetHeading: function _clickFacetHeading() {
      $(".hawk-guidedNavWrapper .hawk-collapsible .hawk-groupHeading").off('click').on('click', function () {
        var i = $(this).closest(".hawk-navGroup");
        i.outerHeight();
        $(".hawk-guidedNavWrapper .hawk-navGroup").each(function (e, n) {
          i[0] !== n && ($(n).addClass("hawk-collapsed"), $(n).removeClass("hawk-notCollapsed"));
        }), $(i).toggleClass("hawk-collapsed");
        i.outerHeight();
        $(this).closest(".hawk-navGroup").toggleClass("hawk-notCollapsed");
        if ($(".hawk-facetScollingContainer").length && $(".hawk-facetScollingContainer").position().top > 0) {
          var n = $(".hawk-facetScollingContainer").outerHeight(),
              o = $(".footer").offset().top,
              s = $(".hawk-facetScollingContainer").offset().top;
          if (n + s > o) {
            var a = $(".hawk-facetScollingContainer").position().top;
            a = a - (n + s - o) - 10, $(".hawk-facetScollingContainer").css("top", a + "px");
          }
          // e.SetFacetScrollPosition()
        }
        var r = i.attr("data-field"),
            l = !1;

        var today = new Date();
        var expirationDate = new Date();
        expirationDate.setDate(today.getDate() + 365);
        var time = expirationDate.getTime();
        var expireTime = time + 1000 * 36000;
        expirationDate.setTime(expireTime);
        i.hasClass("hawk-collapsed") && (l = !0), document.cookie = r + l + ';path=/' + ';expires=' + expirationDate;
      });
    },
    _customHawkImg: function _customHawkImg() {
      var hawkCategoriesImgs = localStorage.getItem('hawkCategoriesImgs');
      var hawkTimestamp = localStorage.getItem('hawkTimestamp');
      var hawkTimestampLs = '';
      if (hawkTimestamp && hawkTimestamp != '' && hawkTimestamp != undefined && hawkTimestamp != null) {
        hawkTimestampLs = new Date(hawkTimestamp);
      }
      var currentTimestamp = new Date();

      var timeDiff = 0;
      if (hawkTimestampLs != '') {
        timeDiff = (currentTimestamp.getTime() - hawkTimestampLs.getTime()) / 3600000;
      }

      if (hawkCategoriesImgs && hawkCategoriesImgs != '' && hawkCategoriesImgs != undefined && hawkCategoriesImgs != null && hawkTimestampLs != '' && timeDiff <= 24) {} else {
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/categories',
          success: function success(data) {
            localStorage.setItem('hawkCategoriesImgs', JSON.stringify(data));
            localStorage.setItem('hawkTimestamp', new Date());
          }
        });
      }
    },
    _customHawk: function _customHawk() {

      app.collection.products = [];
      app.collection.hawkCurrSel = [];
      app.collection.hawkAllCurrSel = [];

      var hawkCategoriesImgs = localStorage.getItem('hawkCategoriesImgs');
      var hawkTimestamp = localStorage.getItem('hawkTimestamp');
      var hawkTimestampLs = '';
      if (hawkTimestamp && hawkTimestamp != '' && hawkTimestamp != undefined && hawkTimestamp != null) {
        hawkTimestampLs = new Date(hawkTimestamp);
      }
      var currentTimestamp = new Date();

      var timeDiff = 0;
      if (hawkTimestampLs != '') {
        timeDiff = (currentTimestamp.getTime() - hawkTimestampLs.getTime()) / 3600000;
      }

      if (hawkCategoriesImgs && hawkCategoriesImgs != '' && hawkCategoriesImgs != undefined && hawkCategoriesImgs != null && hawkTimestampLs != '' && timeDiff <= 24) {
        var catImg = JSON.parse(hawkCategoriesImgs);
      } else {
        var catImg = [];
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/categories',
          success: function success(data) {
            catImg = JSON.parse(JSON.stringify(data));
          }
        });
      }

      var collection_handle = $('.collection-page').data('colloction');
      var pg = app._getUrlParameter('pg');
      var url_pg = '';
      if (pg && pg != undefined && pg != null && pg != '') {
        url_pg = '&pg=' + pg;
      }

      var hwcategory = app._getUrlParameter('category');
      var url_hwcategory = '';
      if (hwcategory && hwcategory != undefined && hwcategory != null && hwcategory != '') {
        url_hwcategory = '&category=' + encodeURIComponent(hwcategory);
      }

      var hwprice = app._getUrlParameter('price_sale');
      var url_hwprice = '';
      if (hwprice && hwprice != undefined && hwprice != null && hwprice != '') {
        url_hwprice = '&price_sale=' + hwprice;
      }

      var vars = [],
          hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars[hash[0]] = hash[1];
      }
      var url_vars = vars.join('&');

      var locationSearch = window.location.search;
      locationSearch = locationSearch.replace('?', '&');

      if (app.currentTemplate == 'collection') {
        var loadUrl = 'lpurl=%2Fcollections%2F' + collection_handle + locationSearch;
      } else {
        var loadUrl = window.location.search.replace('?', '');
      }

      $.ajax({
        type: 'GET',
        url: 'http://lusearchapi-na.hawksearch.com/sites/kitchencenter/?hawkoutput=json&' + loadUrl,
        success: function success(data) {
          app.collection.products = [];
          $.each(data.Results, function (index, item) {
            app.collection.products.push(item);
          });
          app.collection.TrackingId = data.TrackingId;
          app.collection.breadcrumb = data.Breadcrumb;
          app.collection.hawkpagination = data.Pagination;
          app.collection.hawkSorting = data.Sorting;
          app.collection.hawkFacets = data.Facets;
          app.collection.hawkSelections = data.Selections;
          if (data.Keyword != '') {
            app.collection.hawkKeyword = data.Keyword;
          }

          //  Pagination code
          app.collection.hawkpagination.showPgNo = [];
          if (app.collection.hawkpagination.CurrentPage < 4) {
            for (var i = 1; i <= 5; i++) {
              app.collection.hawkpagination.showPgNo.push(i);
            }
          } else {
            if (app.collection.hawkpagination.CurrentPage == app.collection.hawkpagination.NofPages) {
              var forLengthMin = app.collection.hawkpagination.CurrentPage - 4;
              var forLengthMax = app.collection.hawkpagination.CurrentPage;
            } else if (app.collection.hawkpagination.CurrentPage == app.collection.hawkpagination.NofPages - 1) {
              var forLengthMin = app.collection.hawkpagination.CurrentPage - 3;
              var forLengthMax = app.collection.hawkpagination.CurrentPage + 1;
            } else {
              var forLengthMin = app.collection.hawkpagination.CurrentPage - 2;
              var forLengthMax = app.collection.hawkpagination.CurrentPage + 2;
            }

            for (var i = forLengthMin; i <= forLengthMax; i++) {
              app.collection.hawkpagination.showPgNo.push(i);
            }
          }
          //  end Pagination code

          var locSrchOrg = window.location.search;
          var locSrchPg = locSrchOrg;
          if (app.currentTemplate == 'collection') {
            if (locSrchOrg.indexOf('pg=') > -1) {
              locSrchPg = locSrchPg.replace('&pg=' + app.collection.hawkpagination.CurrentPage, '').replace('pg=' + app.collection.hawkpagination.CurrentPage + '&', '').replace('pg=' + app.collection.hawkpagination.CurrentPage, '');
            }
            if (locSrchPg == '') {
              app.collection.hawkpagination.linkUrl = collection_handle + '?';
            } else if (locSrchPg == '?') {
              app.collection.hawkpagination.linkUrl = collection_handle + locSrchPg;
            } else {
              app.collection.hawkpagination.linkUrl = collection_handle + locSrchPg + '&';
            }
          } else {
            if (locSrchOrg.indexOf('pg=') > -1) {
              locSrchPg = locSrchPg.replace('&pg=' + app.collection.hawkpagination.CurrentPage, '').replace('pg=' + app.collection.hawkpagination.CurrentPage + '&', '').replace('pg=' + app.collection.hawkpagination.CurrentPage, '');
            }
            if (locSrchPg == '') {
              app.collection.hawkpagination.linkUrl = 'search?';
            } else if (locSrchPg == '?') {
              app.collection.hawkpagination.linkUrl = 'search' + locSrchPg;
            } else {
              app.collection.hawkpagination.linkUrl = 'search' + locSrchPg + '&';
            }
          }
          // pagination

          // sorting
          var locSrch = locSrchOrg.replace('?', '');
          var removeSortItm = app.collection.hawkSorting.Items.find(function (item) {
            return item.Selected === true;
          });

          app.collection.hawkSorting.Items.forEach(function (item, index) {

            if (locSrch.indexOf('sort=') > -1) {
              var removeSort1 = '&sort=' + removeSortItm.Value;
              var removeSort2 = 'sort=' + removeSortItm.Value + '&';
              var removeSort3 = 'sort=' + removeSortItm.Value;
              locSrch = locSrch.replace(removeSort1, '').replace(removeSort2, '').replace(removeSort3, '');
            }

            // collection_handle+'?'
            if (locSrch == '') {
              app.collection.hawkSorting.Items[index].linkUrl = collection_handle + '?sort=' + item.Value;
            } else {
              app.collection.hawkSorting.Items[index].linkUrl = collection_handle + '?' + locSrch + '&sort=' + item.Value;
            }
          });

          // const dataoption = [];

          var hawkAllCategoriesLocalStrg = localStorage.getItem('hawkAllCategories');

          if (app.collection.hawkAllCategories.length == 0) {
            if (hawkAllCategoriesLocalStrg && hawkAllCategoriesLocalStrg != '' && hawkAllCategoriesLocalStrg != undefined) {
              app.collection.hawkAllCategories = JSON.parse(hawkAllCategoriesLocalStrg);
            }
          }

          var availSelCat = [];
          app.collection.hawkFacets.forEach(function (item, index) {
            if (item.ParamName == 'category') {
              item.Values.forEach(function (subvalue, index) {
                $.each(catImg, function (k, value) {
                  if (subvalue.Label.toLowerCase() == value.name.toLowerCase()) {
                    item.Values[index].comImg = value.url;
                  }
                });

                availSelCat.push(subvalue.Value);
              });
            }

            if (item.ParamName == 'color') {
              var SwatchData = item.SwatchData;
              item.SwatchData = JSON.parse(SwatchData);

              item.Values.forEach(function (subvalue, index) {
                item.SwatchData.forEach(function (swatchvalue, ind) {
                  if (subvalue.Value == swatchvalue.Value) {
                    item.Values[index].swatchimg = swatchvalue.AssetName;
                  }
                });
              });
            }

            var url = window.location.pathname + window.location.search;

            if ($.isEmptyObject(app.collection.hawkSelections) == false) {
              var arrayitem = [];

              var currentSel = [];
              var currentCat = [];
              var currentSelCat = [];
              // item.Values.forEach((subvalue, index) => {
              $.each(app.collection.hawkSelections, function (selitem) {
                currentCat.push(selitem);
                $.each(app.collection.hawkSelections[selitem].Items, function (sellblitem) {
                  var selValue = app.collection.hawkSelections[selitem].Items[sellblitem].Value;
                  // if(selValue == subvalue.Value){
                  currentSel.push(selValue);
                  if (selitem == 'category') {
                    currentSelCat.push(selValue);
                  }
                  // }

                  var locSearch = window.location.search;
                  locSearch = locSearch.replace('?', '').replaceAll('%20', ' ').replaceAll('%C3%B1', 'ñ').replaceAll('%C3%A1', 'á').replaceAll('%C3%A9', 'é').replaceAll('%C3%81', 'á').replaceAll('%C3%B3', 'ó');

                  var makelink = '';
                  if (app.collection.hawkSelections[selitem].Items.length == 1) {
                    var removecat = selitem + '=' + selValue;
                    makelink = locSearch.replace(removecat, '');
                  } else {
                    var removecat1 = selValue + ',';
                    var removecat2 = ',' + selValue;
                    makelink = locSearch.replace(removecat1, '').replace(removecat2, '');
                  }

                  if (app.currentTemplate == 'collection') {
                    makelink = makelink.indexOf('&') == 0 ? makelink.substring(1) : makelink;
                    var pos = makelink.lastIndexOf('&&');
                    makelink = makelink.substring(0, pos) + '' + makelink.substring(pos + 1);
                  }

                  if (app.currentTemplate != 'collection') {
                    makelink = makelink.replace('search=&searchInput=' + app.collection.hawkKeyword + '&', '');
                  }

                  if (makelink != '') {
                    if (app.currentTemplate == 'collection') {
                      var linkUrl = collection_handle + '?' + makelink;
                    } else {
                      var linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword + '&' + makelink;
                    }
                  } else {
                    if (app.currentTemplate == 'collection') {
                      var linkUrl = collection_handle;
                    } else {
                      var linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword;
                    }
                  }
                  app.collection.hawkSelections[selitem].Items[sellblitem].linkUrl = linkUrl;
                });
              });
              // });

              app.collection.hawkCurrSel = currentSelCat;
              app.collection.hawkAllCurrSel = currentSel;

              item.Values.forEach(function (subvalue, index) {
                var newurl = '';
                var caturl = '';

                var arrCounter = 0;
                $.each(app.collection.hawkSelections, function (selitem) {
                  arrCounter = arrCounter + 1;
                  // item.Values[index].selitem = [];
                  var catVal = '';
                  $.each(app.collection.hawkSelections[selitem].Items, function (sellblitem) {
                    var selValue = app.collection.hawkSelections[selitem].Items[sellblitem].Value;
                    if (selValue != subvalue.Value) {
                      if (catVal == '') {
                        catVal = selValue;
                      } else {
                        catVal = catVal + ',' + selValue;
                      }
                      if (item.ParamName == selitem) {
                        if (catVal.indexOf(subvalue.Value) == -1 && $.inArray(subvalue.Value, currentSel) == -1) {
                          catVal = catVal + ',' + subvalue.Value;
                        }
                      }
                      if (caturl.indexOf(selitem + '=' + catVal) <= -1) {
                        caturl = selitem + '=' + catVal;
                      }
                    }
                  });

                  if ($.inArray(item.ParamName, currentCat) == -1 && arrCounter == 1) {
                    if (caturl.indexOf(item.ParamName + '=' + subvalue.Value) <= -1) {
                      caturl = caturl + '&' + item.ParamName + '=' + subvalue.Value;
                    }
                  }

                  if (newurl == '') {
                    newurl = caturl;
                  } else {
                    if (newurl.indexOf(caturl) <= -1) {
                      newurl = newurl + '&' + caturl;
                    } else {
                      newurl = caturl;
                    }
                  }
                });

                if (newurl != '') {
                  if (app.currentTemplate == 'collection') {
                    item.Values[index].linkUrl = collection_handle + '?' + newurl;
                  } else {
                    item.Values[index].linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword + '&' + newurl;
                  }
                } else {
                  if (app.currentTemplate == 'collection') {
                    item.Values[index].linkUrl = collection_handle;
                  } else {
                    item.Values[index].linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword;
                  }
                }
                if (item.ParamName == 'category') {
                  if (app.collection.hawkAllCategories && app.collection.hawkAllCategories != undefined) {
                    $.each(app.collection.hawkAllCategories, function (ind, allcat) {
                      if (subvalue.Value == allcat.Value) {
                        app.collection.hawkAllCategories[ind].isActive = true;
                        if (newurl != '') {
                          if (app.currentTemplate == 'collection') {
                            app.collection.hawkAllCategories[ind].linkUrl = collection_handle + '?' + newurl;
                          } else {
                            app.collection.hawkAllCategories[ind].linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword + '&' + newurl;
                          }
                        } else {
                          if (app.currentTemplate == 'collection') {
                            app.collection.hawkAllCategories[ind].linkUrl = collection_handle;
                          } else {
                            app.collection.hawkAllCategories[ind].linkUrl = '/search?search=&searchInput=' + app.collection.hawkKeyword;
                          }
                        }
                      }
                    });
                  }
                }
              });
            } else {
              item.Values.forEach(function (subvalue, index) {
                var caturl = '';
                var locSearch = window.location.search;
                if (app.currentTemplate == 'collection') {
                  if (caturl.indexOf(item.ParamName + '=' + subvalue.Value) <= -1) {
                    caturl = '?' + item.ParamName + '=' + subvalue.Value;
                  }

                  item.Values[index].linkUrl = collection_handle + caturl;
                } else {
                  if (caturl.indexOf(item.ParamName + '=' + subvalue.Value) <= -1) {
                    caturl = app.collection.hawkKeyword + '&' + item.ParamName + '=' + subvalue.Value;
                  }

                  item.Values[index].linkUrl = '/search?search=&searchInput=' + caturl;
                }
              });
              if (item.ParamName == 'category') {
                app.collection.hawkAllCategories = item.Values;
                var sortingHawk = window.theme.collectionOrder.replaceAll(', ', ',').replaceAll(' ,', ',').split(',');

                var resultHawk = [];

                sortingHawk.forEach(function (key) {
                  var found = false;
                  item.Values = item.Values.filter(function (item) {
                    if (!found && item['Label'].toLowerCase() == key.toLowerCase()) {
                      resultHawk.push(item);
                      found = true;
                      return false;
                    } else return true;
                  });
                });

                var diffArray = item.Values;
                diffArray = diffArray.filter(function (ar) {
                  return !resultHawk.find(function (rm) {
                    return rm['Label'].toLowerCase() === ar['Label'].toLowerCase();
                  });
                });
                var mergeArray = resultHawk.concat(diffArray);

                app.collection.hawkAllCategories = mergeArray;

                localStorage.setItem('hawkAllCategories', JSON.stringify(app.collection.hawkAllCategories));
              }
            }
          });

          app.collection.hawkAvailCategories = availSelCat;
        }
      }).then(function () {

        if (app.collection.hawkAvailCategories.length > 0) {
          $('.category-img-filter').css('display', 'block');
        } else {
          $('.category-img-filter').css('display', 'none');
        }

        $(".category-img-div a, .selected-facet-wrapper li.hawkFacet-active > a").css('pointer-events', 'auto');
        $('.hawk-loader').addClass('d-none');

        app._clickFacetHeading();

        $(".hawkRailNav .hawk-navGroup li > a").on("click", function (e) {
          e.preventDefault();
          var i = $(this).parent();
          "mouseover" == e.type ? i.addClass("hawkFacet-hover") : "mouseout" == e.type ? i.removeClass("hawkFacet-hover") : "click" == e.type && (e.preventDefault(), i.hasClass("hawkFacet-indetermined") ? (i.removeClass("hawkFacet-indetermined"), i.addClass("hawkFacet-active"), i.find("> ul > li ").removeClass("hawkFacet-active"), i.find("> ul > li ").removeClass("hawkFacet-hover")) : (i.toggleClass("hawkFacet-active"), i.removeClass("hawkFacet-hover")), $(i).find(".hawkFacet-active").removeClass("hawkFacet-active"), $(i).parentsUntil(".hawk-navGroupContent", "ul").each(function () {
            var e = $(this);
            e.find("li.hawkFacet-active").length;
            if (e.find("li").length > 0) {
              var i = $(this).closest("li");
              i.removeClass("hawkFacet-active"), i.removeClass("hawkFacet-hover"), i.addClass("hawkFacet-indetermined");
            }
          }));
        });

        // $(".hawkfacets").on("click", ".slider-clear, .hawk-facetFilters a", function (t) {
        $(".hawkfacets .slider-clear, .hawkfacets .hawk-facetFilters a").off('click').on("click", function (e) {
          $('.hawk-loader').removeClass('d-none');
          $("#hdnhawkpg").val("");

          var i = $(this).data().options,
              n = $(this).parents("ul.hawk-facetFilters");
          $(this).parents(".hawk-navGroup").addClass('hawk-collapsed');
          if ($(window).width() > 767) {
            $(this).parents(".hawk-navGroup").removeClass('hawk-notCollapsed');
          }

          return n.hasClass("singlefacet") && n.find(".hawkFacet-active a").each(function () {
            var t = $(this).data().options;
            i.value !== t.value && $(this).parent().removeClass("hawkFacet-active");
          }),
          // document.location.search = params,
          // var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?arg=1';
          window.history.pushState({ path: $(this).attr('href') }, '', $(this).attr('href')), app._customHawk(), !1;
        });

        $(".category-img-div a, .selected-facet-wrapper li.hawkFacet-active > a, .hawk-clearSelected > a").off('click').on("click", function (e) {
          e.preventDefault();
          $(".category-img-div a, .selected-facet-wrapper li.hawkFacet-active > a").css('pointer-events', 'none');
          $('.hawk-loader').removeClass('d-none');
          window.history.pushState({ path: $(this).attr('href') }, '', $(this).attr('href'));
          app._customHawk();
        });

        $("#mobile-facets-btn").off('click').on("click", function (event) {
          var e = $("#hawkRailNav");
          e.hasClass("hawkRailNav--visible") ? e.removeClass("hawkRailNav--visible") : e.addClass("hawkRailNav--visible");
        });

        $("#hawkRailNav-header-close").off('click').on("click", function (event) {
          var e = $("#hawkRailNav");
          e.hasClass("hawkRailNav--visible") ? e.removeClass("hawkRailNav--visible") : e.addClass("hawkRailNav--visible");
        });

        $("#hawkRailNav-footer-clear-btn").off('click').on("click", function (event) {
          $('.hawk-clearSelected a')[0].click();
        });

        $("#hawkRailNav-footer-apply-btn").off('click').on("click", function (event) {
          $("#hawkRailNav").removeClass("hawkRailNav--visible");
        });

        $('.sortList .hawksortby').on("change", function (e) {
          e.preventDefault();
          window.history.pushState({ path: $(this).val() }, '', $(this).val());
          app._customHawk();
        });
      });
    },
    _hawkSearch: function _hawkSearch() {
      var urlData = window.location.href.split('searchInput=')[1];
      $.ajax({
        type: 'POST',
        url: "https://lusearchapi-na.hawksearch.com/sites/kitchencenter/?searchInput=" + urlData + "&output=json",
        success: function success(data) {
          if (data.Location != '') {
            window.location.href = data.Location;
          }
        },
        error: function error(_error) {}
      });
    },
    _HawkSubmit: function _HawkSubmit(i) {
      var n = $(i).find("input[name=" + $("#hdnhawkkeywordfield").val() + "]"),
          o = $(n).val(),
          s = $(n).attr("id");
      return 0 == n.length && 0 == $("#hdnhawkkeyword").length || o != e.SuggesterGlobal.defaultKeyword[s] && o != $("#hdnhawkkeyword").val();
    },
    _customHawkSuggestion: function _customHawkSuggestion() {
      $('#searchInput').keyup(app._debounce(function () {
        var thisVal = $(this).val();
        $.ajax({
          type: 'GET',
          url: 'http://lusearchapi-na.hawksearch.com/sites/kitchencenter//?hawkoutput=json&fn=ajax&f=GetSuggestions&q=' + thisVal,
          success: function success(data) {
            $('#querydiv').html('');
            if (data.Popular.length > 0) {
              var searchHtmlCol = '';
              searchHtmlCol += '<div class="hawk-sqHeader">' + data.PopularHeading + '</div>';
              searchHtmlCol += '<ul class="hawk-sqContent">';
              $.each(data.Popular, function (index, item) {
                searchHtmlCol += '<li class="hawk-sqItem" data-url="' + item.Url + '" data-autocompletetype="1" onclick="window.location=&quot;' + item.Url + '&quot;">';
                searchHtmlCol += "<h1 class=\"hawk-sqItemName\">" + item.Value + "</h1>";
                searchHtmlCol += '</li>';
              });
              searchHtmlCol += '</ul>';
              searchHtmlCol += '<div class="hawk-sqFooter"></div>';
              $('#querydiv').append(searchHtmlCol);
            }

            if (data.Products.length > 0) {
              var searchHtml = '';
              searchHtml += '<div class="hawk-sqHeader">' + data.ProductHeading + '</div>';
              searchHtml += '<ul class="hawk-sqContent">';
              $.each(data.Products, function (index, item) {
                searchHtml += '<li class="hawk-sqItem" data-url="' + item.Url + '" data-autocompletetype="3">';
                // onclick="window.location=&quot;'+item.Url+'&quot;"
                searchHtml += item.Html;
                searchHtml += '</li>';
              });
              searchHtml += '</ul>';
              searchHtml += '<div class="hawk-sqFooter"></div>';
              $('#querydiv').append(searchHtml);
            }

            if (data.Products.length > 0 || data.Popular.length > 0) {
              $('#querydiv').show();

              $('body').on('click', '.hawk-sqItem', function (e) {
                e.preventDefault();
                HawkSearch.Tracking.track('autocompleteclick', {
                  keyword: $('#searchInput').val(),
                  name: $(e.currentTarget).find('.hawk-sqItemContent h1').text(),
                  suggest_type: $(e.currentTarget).attr('data-autocompletetype'),
                  itemUrl: $(e.currentTarget).attr('data-url')
                });
                window.location.href = $(e.currentTarget).attr('data-url');
              });
            } else {
              $('#querydiv').hide();
            }
          }
        });
      }, 400));

      $('#searchInput').focus(function () {
        $(this).val('');
      });
    },
    _customrecommendation: function _customrecommendation() {
      $('.hawk-recommendation').each(function () {
        var widgetGuid = $(this).attr('data-widgetguid');

        if (app.currentTemplate == 'product') {
          var uniqueId = app.currentVariant.id;
        } else {
          var uniqueId = null;
        }

        var _context = {
          "visitId": app._getCookie('visit_id'),
          "visitorId": app._getCookie('visitor_id'),
          "baseUrl": app._getHawkUrl(),
          "clientGuid": app._getClientGuid(),
          "enablePreview": false,
          "widgetUids": [{
            "widgetGuid": widgetGuid,
            "uniqueId": uniqueId
          }],
          "contextProperties": {
            uniqueid: uniqueId
          },
          "customProperties": {}
        };
        $.ajax({
          type: "POST",
          url: 'http://recs-na.hawksearch.com/api/recommendation/',
          data: JSON.stringify(_context),
          contentType: "application/json",
          Accept: "application/json",
          dataType: "json"
        }).done(function (data) {
          app._RegWidgets(data);
        });
      });
    },
    _waitForImages: function _waitForImages(i, n, o) {
      var s = 0,
          a = 0;
      if (e.isPlainObject(arguments[0]) && (o = arguments[0].waitForAll, n = arguments[0].each, i = arguments[0].finished), i = i || e.noop, n = n || e.noop, o = !!o, !e.isFunction(i) || !e.isFunction(n)) throw new TypeError("An invalid callback was supplied.");
      return this.each(function () {
        var r = e(this),
            l = [],
            c = e.waitForImages.hasImageProperties || [],
            h = /url\(\s*(['"]?)(.*?)\1\s*\)/g;
        o ? r.find("*").addBack().each(function () {
          var t = e(this);
          t.is("img:uncached") && l.push({
            src: t.attr("src"),
            element: t[0]
          }), e.each(c, function (e, i) {
            var n,
                o = t.css(i);
            if (!o) return !0;
            for (; n = h.exec(o);) {
              l.push({
                src: n[2],
                element: t[0]
              });
            }
          });
        }) : r.find("img:uncached").each(function () {
          l.push({
            src: this.src,
            element: this
          });
        }), s = l.length, a = 0, 0 === s && i.call(r[0]), e.each(l, function (o, l) {
          var c = new Image();
          e(c).on("load." + t + " error." + t, function (e) {
            return a++, n.call(l.element, a, s, "load" == e.type), a == s ? (i.call(r[0]), !1) : void 0;
          }), c.src = l.src;
        });
      });
    },
    _matchHeights: function _matchHeights(e) {
      var t = (e = jQuery.extend(this, {
        minHeight: null,
        maxHeight: null,
        extension: 0,
        overflow: null,
        includeMargin: !1
      }, e)).extension,
          i = e.minHeight ? e.minHeight : 0;
      return this.each(function () {
        i = Math.max(i, s(this).outerHeight());
      }), e.maxHeight && i > e.maxHeight && (i = e.maxHeight), this.each(function () {
        var n = s(this),
            o = n.innerHeight() - n.height() + (n.outerHeight(e.includeMargin) - n.innerHeight());
        e.overflow ? n.css({
          height: i - o + t,
          overflow: e.overflow
        }) : n.css({
          "min-height": i - o + t
        });
      });
    },
    _ExposeEvents: function _ExposeEvents(e, i) {
      var n = $.Event("hawk" + e, i);
      return $("body").trigger(n), !n.isDefaultPrevented();
    },
    _Dictionary: function _Dictionary() {
      function e() {
        if (!(this instanceof e)) return new e();
      }
      return e.prototype.count = function () {
        var e,
            t = 0;
        for (e in this) {
          this.hasOwnProperty(e) && (t += 1);
        }return t;
      }, e.prototype.keys = function () {
        var e,
            t = [];
        for (e in this) {
          this.hasOwnProperty(e) && t.push(e);
        }return t;
      }, e.prototype.values = function () {
        var e,
            t = [];
        for (e in this) {
          this.hasOwnProperty(e) && t.push(this[e]);
        }return t;
      }, e.prototype.keyValuePairs = function () {
        var e,
            t = [];
        for (e in this) {
          this.hasOwnProperty(e) && t.push({
            Key: e,
            Value: this[e]
          });
        }return t;
      }, e.prototype.add = function (e, t) {
        this[e] = t;
      }, e.prototype.clear = function () {
        var e;
        for (e in this) {
          this.hasOwnProperty(e) && delete this[e];
        }
      }, e.prototype.containsKey = function (e) {
        return this.hasOwnProperty(e);
      }, e.prototype.containsValue = function (e) {
        var t;
        for (t in this) {
          if (this.hasOwnProperty(t) && this[t] === e) return !0;
        }return !1;
      }, e.prototype.remove = function (e) {
        return !!this.hasOwnProperty(e) && (delete this[e], !0);
      }, e;
    },
    _getHawkUrl: function _getHawkUrl() {
      return HawkSearch.HawkUrl === undefined || "" === HawkSearch.HawkUrl ? HawkSearch.BaseUrl : HawkSearch.HawkUrl;
    },
    _getClientGuid: function _getClientGuid() {
      return HawkSearch.ClientGuid !== undefined ? HawkSearch.ClientGuid : "";
    },
    _RegWidgets: function _RegWidgets(data) {
      data.isSuccess ? ($(data.items).each(function () {
        var item = this,
            contaierSelector = '.hawk-recommendation[data-widgetguid="' + item.widgetGuid + '"]',
            widgetContainer = $(contaierSelector);
        if (widgetContainer.length > 0) {
          widgetContainer.attr("data-hawk-requestid", data.requestId);
          var layoutClass = "hawk-recommendation-" + (item.isVertical ? "vertical" : "horizontal");
          widgetContainer.addClass(layoutClass), widgetContainer.append("<div class='hawk-recommendation-inner'></div>");
          var widgetContainerInner = widgetContainer.find(".hawk-recommendation-inner");
          widgetContainerInner.css("visibility", "hidden"), widgetContainerInner.html(item.html);
          var hawkRecommendationItems = widgetContainerInner.find(".hawk-recommendation-item");
          // widgetContainerInner.app._waitForImages(function () {
          var itemContainer = widgetContainerInner.find(".hawk-recommendation-list");
          var container = $("#hawkitemlist");
          if (app._ExposeEvents("RecommenderAfterWidgetImagesLoaded", {
            widgetContainer: widgetContainer
          }), item.isCarousel) {
            item.carouselData.showNextPrevButtons && widgetContainerInner.addClass("has-arrows"), item.carouselData.showDots && widgetContainerInner.addClass("has-dots vertical-dots");
            var autoRotateSpeed = item.carouselData.autoRotate ? item.carouselData.autoRotateSpeed : 0,
                showDots = item.carouselData.showDots,
                slickOptions = {
              speed: item.carouselData.animationSpeed,
              autoplay: item.carouselData.autoRotate,
              autoplaySpeed: item.carouselData.autoRotateSpeed,
              vertical: item.isVertical,
              slidesToShow: item.carouselData.nofVisible,
              arrows: item.carouselData.showNextPrevButtons,
              nextArrow: '<button type="button" class="hawk-carousel-next"><span>Next</span></button>',
              prevArrow: '<button type="button" class="hawk-carousel-prev"><span>Prev</span></button>',
              slidesToScroll: item.carouselData.scrollNumber,
              infinite: item.carouselData.isCircular,
              dots: item.carouselData.showDots,
              slide: ".hawk-recommendation-item",
              pauseOnHover: !0,
              pauseOnDotsHover: !0,
              mobileFirst: !0
            };
            if (item.carouselData.enableResponsive) {
              var responsiveConfig = null;
              try {
                responsiveConfig = eval("(" + item.carouselData.responseiveConfig + ")");
              } catch (e) {
                log("Responsive data is corupted. WidgetGuid: " + item.widgetGuid + " Error:" + e);
              }
              null != responsiveConfig && (slickOptions.responsive = responsiveConfig);
            }
            if (itemContainer.slick(slickOptions), item.isVertical) var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(!0);else var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(!0),
                itemCount = item.carouselData.nofVisible;
            $(window).on("debouncedresize", function () {
              itemContainer.slick("slickGoTo", itemContainer.slick("slickCurrentSlide"), !0);
            });
          } else if (item.isVertical) widgetContainer.width(widgetContainerInner.width() + "px");else {
            var itemWidth = itemContainer.find(".hawk-recommendation-item:visible").first().outerWidth(!0),
                itemCount = itemContainer.find(".hawk-recommendation-item").length;
            itemContainer.width(itemWidth * itemCount), widgetContainer.height(widgetContainerInner.height() + "px");
          }
          widgetContainer.append("<div class='clearfix'></div>"), widgetContainerInner.css("visibility", "visible");
          var enablePreview = true;
          if (enablePreview) {
            var ruleExplainDictionary = app._Dictionary,
                triggerRuleExplainDictionary = app._Dictionary,
                bindPreview = function bindPreview(e) {
              for (i = 0; i < e.length; i++) {
                var t = e[i];
                ruleExplainDictionary[t.ModelGuid] = t.RuleString, triggerRuleExplainDictionary[t.ModelGuid] = t.TriggerRuleString;
              }
              app_.bindRecommendationPopover(widgetContainerInner, ruleExplainDictionary, triggerRuleExplainDictionary);
            };
            $(window).on("debouncedresize", function () {
              $(".hawk-recommendation-info").each(function (e, t) {
                HawkSearch.PopoverAction($(t), "destroy");
              }), setTimeout(function () {
                app._bindRecommendationPopover(widgetContainerInner, ruleExplainDictionary, triggerRuleExplainDictionary);
              }, 10);
            });
            var uriParser = document.createElement("a"),
                url = uriParser.href = HawkSearch.HawkUrl || HawkSearch.BaseUrl,
                apiUrl = uriParser.protocol + "//" + uriParser.hostname + "/api/v3/RecommendationModel/getruleexplain?widgetGuid=" + item.widgetGuid + "&bu=" + encodeURIComponent(app._getHawkUrl()) + "&cg=" + app._getClientGuid();
            $.ajax({
              url: apiUrl,
              dataType: "jsonp",
              success: app._bindPreview(data)
            });
          }
          // })
        }
      }), app._hideRecsBlockUI(), app._ExposeEvents("RecommenderAfterInit")) : app._hideRecsBlockUI();
    },
    _hideRecsBlockUI: function _hideRecsBlockUI() {
      $(".hawk-recommendation").css("height", "auto");
    },
    _bindPreview: function _bindPreview(e) {
      for (var i = 0; i < e.length; i++) {
        var t = e[i];
        var widgetContainer = $('.hawk-recommendation');
        var widgetContainerInner = widgetContainer.find(".hawk-recommendation-inner");
        var ruleExplainDictionary = app._Dictionary,
            triggerRuleExplainDictionary = app._Dictionary;
        ruleExplainDictionary[t.ModelGuid] = t.RuleString, triggerRuleExplainDictionary[t.ModelGuid] = t.TriggerRuleString;
      }
      app._bindRecommendationPopover(widgetContainerInner, ruleExplainDictionary, triggerRuleExplainDictionary);
    },
    _bindRecommendationPopover: function _bindRecommendationPopover(e, t, i) {
      if (e != undefined) {
        e.find(".hawk-recommendation-item").each(function () {
          var e = $(this).data("hawk-modeltype"),
              n = $(this).data("hawk-modelname"),
              o = $(this).data("hawk-modelguid"),
              s = $(this).find(".hawk-recommendation-info");
          0 === s.length && ((s = $("<div class='hawk-recommendation-info' data-trigger='hover'></div>")).append($("<div class='hawk-recommendation-model-icon hawk-" + e.toLowerCase() + "'></div>")), $(this).prepend(s));
          var a = t[o],
              r = i[o],
              l = "<b>Strategy Name:</b> " + n;
          a !== undefined && "" !== a && (l += "<div class=''>", l += "<div class=''><b>Rule:</b></div>", l += a, l += "</div>"), r !== undefined && "" !== r && (l += "<div class=''>", l += "<div class=''><b>Trigger Rule:</b></div>", l += r, l += "</div>"), app._Popover($(s), app._getTipPlacementFunction("top", 230, 200), l);
        });
      }
    },
    _getTipPlacementFunction: function _getTipPlacementFunction(e, i, n) {
      return function (o, s) {
        var t = $;
        var a,
            r,
            l,
            c,
            h,
            d = t(s),
            u = t(document).scrollTop(),
            p = t(document).scrollLeft(),
            f = p + t(window).width(),
            m = u + t(window).height(),
            g = t.extend({}, d.offset(), {
          width: s.offsetWidth,
          height: s.offsetHeight
        }),
            v = function v(e) {
          return u < e.top && p < e.left && f > e.left + i && m > e.top + n;
        },
            w = function w() {
          return !1 !== r && !!(r = v({
            top: g.top - n,
            left: g.left + g.width / 2 - i / 2
          })) && "top";
        },
            k = function k() {
          return !1 !== l && !!(l = v({
            top: g.top + g.height,
            left: g.left + g.width / 2 - i / 2
          })) && "bottom";
        },
            y = function y() {
          return !1 !== c && !!(c = v({
            top: g.top + g.height / 2 - n / 2,
            left: g.left - i
          })) && "left";
        },
            b = function b() {
          return !1 !== h && !!(h = v({
            top: g.top + g.height / 2 - n / 2,
            left: g.left + g.width
          })) && "right";
        };
        switch (e) {
          case "top":
            if (a = w()) return a;
          case "bottom":
            if (a = k()) return a;
          case "left":
            if (a = y()) return a;
          case "right":
            if (a = b()) return a;
          default:
            return (a = w()) ? a : (a = k()) ? a : (a = y()) ? a : (a = b()) ? a : e;
        }
      };
    },
    _Popover: function _Popover(i, n, o) {
      $(i).webuiPopover({
        html: !0,
        trigger: "hover",
        content: '<div class="hawk-detail-content">' + o + "<div>",
        placement: n,
        onShow: function onShow(n) {
          e.PrefixClasses(n, "hawk-", ".hawk-detail-content");
          $(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned");
          $(n).on("click", ".onoffswitch-label", function () {
            var i = t(n).find(".onoffswitch-checkbox");
            i.prop("checked", !i.prop("checked")), i.toggleClass("toggle-item-pin");
            var o = $(i).prop("checked"),
                s = $(i).attr("primary-key");
            o ? (e.addToTop(i, s), t(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o)) : (e.unpinItem(i, s), $(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o));
            $(i).parents(".hawk-itemWrapper").find(".hdn-itemPinned").val(o), $("#hawkitemlist").sortable("option", "disabled", !0), $(".hawk-preview-info").addClass("hawk-no-sortable");
          });
        },
        onHide: function onHide(i) {
          $(i).off("click", ".onoffswitch-label"), e.PrefixClasses(i, "hawk-", ".hawk-detail-content");
        }
      });
    },
    _getVisitExpiry: function _getVisitExpiry() {
      var e = new Date();
      return e.setTime(e.getTime() + 144e5), e.toGMTString();
    },
    _getVisitId: function _getVisitId() {
      app._getCookie('selCommonR');
      var e = app._getCookie(this.visit_id_cookie);
      return e || (e = this.createUUID()), this.setCookie(this.visit_id_cookie, e, app._getVisitExpiry()), e;
    }
  }

};

export default customMethods;